import { UIMetadataComplete } from '../../../types/UIMetadata';

/**
 * Cadillac CT5 — Blackwing (linkId 2384).
 *
 * UI half of the 2.0 metadata pair: every key here mirrors a configurationId in
 * ./graphics-metadata.ts. Converted from the 1.0 repo's
 * `src/metadata/data/metadata-2384.ts`; shared UI boilerplate
 * (staticTranslations / saveFormConfig) follows the 2378 project.
 *
 * Assets live in public/assets/{images,videos}/2384/ — paths below are relative
 * to `assets/` and resolved by `assetSrc()` in src/utils/metadata.ts.
 */
// Cast through unknown to allow additional model-level UI fields (e.g., name, specifications)
export const uimetadata = {
  models: {
    CT5: {
      variants: {
        blackwing: {
          configurationId: 's8na5ehwdd44',
          name: {
            en: 'CT5-V Blackwing',
            ar: 'CT5-V Blackwing'
          },
          description: {
            en: 'CT5-V Blackwing',
            ar: 'CT5-V Blackwing'
          },
          drivetrain: '',
          trim: 'Blackwing',
          highlights: [
            {
              en: '6.2L Supercharged V8 Engine',
              ar: 'محرك V8 سوبرتشارجد سعة 6.2 لتر'
            },
            {
              en: 'Google built-in infotainment with 33" advanced color LED display',
              ar: 'نظام معلومات وترفيه مع نظام Google المدمج وشاشة LED متطورة ملوّنة قياس 33 بوصة'
            },
            {
              en: 'AKG Premium Audio sound system',
              ar: 'نظام AKG Premium الصوتي'
            }
          ],
          specs: [
            {
              en: '6.2L Supercharged V8 Engine',
              ar: 'محرك V8 سوبرتشارجد سعة 6.2 لتر'
            },
            {
              en: '668 HP / 893 NM',
              ar: '668 حصاناً / 893 نيوتن متر'
            }
          ],
          image: 'images/2384/variant_ct5bw.png',
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            LBP: 0,
            default: 0,
          },
          index: 0,
          isDefault: true,
          ar: {
            enable: false,
            redirection: false
          },
          toggleTabs: {
            CONFIG: {
              mobile: false,
              desktop: false
            },
            MODEL: {
              mobile: true,
              desktop: true
            },
            EXTERIOR: {
              mobile: true,
              desktop: true
            },
            INTERIOR: {
              mobile: true,
              desktop: true
            },
            OPTIONS: {
              mobile: true,
              desktop: true
            },
            SUMMARY: {
              mobile: true,
              desktop: true
            }
          },
          autoIntelRPOCode: '1SV',
          brandItemCode: 'CACT504',
        },
        v_series: {
          configurationId: 'ct5vseries01',
          name: {
            en: 'CT5 - V-Series',
            ar: 'CT5 - V-Series'
          },
          description: {
            en: 'CT5 V-Series',
            ar: 'CT5 V-Series'
          },
          drivetrain: '',
          trim: 'V-Series',
          highlights: [
            {
              en: 'Available Technology Package',
              ar: 'حزمة التكنولوجيا المتاحة'
            },
            {
              en: 'Available Platinum Package',
              ar: 'حزمة البلاتينيوم المتاحة'
            }
          ],
          specs: [],
          image: 'images/2384/variant_ct5vseries.png',
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            LBP: 0,
            default: 0,
          },
          index: 1,
          isDefault: false,
          ar: {
            enable: false,
            redirection: false
          },
          toggleTabs: {
            CONFIG: {
              mobile: false,
              desktop: false
            },
            MODEL: {
              mobile: true,
              desktop: true
            },
            EXTERIOR: {
              mobile: true,
              desktop: true
            },
            INTERIOR: {
              mobile: true,
              desktop: true
            },
            OPTIONS: {
              mobile: true,
              desktop: true
            },
            SUMMARY: {
              mobile: true,
              desktop: true
            }
          },
          autoIntelRPOCode: '1SF',
          brandItemCode: 'CACT503',
        },
        premium_luxury: {
          configurationId: 'ct5premiumluxury01',
          name: {
            en: 'CT5 - Premium Luxury',
            ar: 'CT5 - Premium Luxury'
          },
          description: {
            en: 'CT5 Premium Luxury',
            ar: 'CT5 Premium Luxury'
          },
          drivetrain: '',
          trim: 'Premium Luxury',
          highlights: [
            {
              en: 'Available Technology Package',
              ar: 'حزمة التكنولوجيا المتاحة'
            },
            {
              en: 'Available Platinum Package',
              ar: 'حزمة البلاتينيوم المتاحة'
            }
          ],
          specs: [],
          image: 'images/2384/variant_ct5premiumluxury.png',
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            LBP: 0,
            default: 0,
          },
          index: 2,
          isDefault: false,
          ar: {
            enable: false,
            redirection: false
          },
          toggleTabs: {
            CONFIG: {
              mobile: false,
              desktop: false
            },
            MODEL: {
              mobile: true,
              desktop: true
            },
            EXTERIOR: {
              mobile: true,
              desktop: true
            },
            INTERIOR: {
              mobile: true,
              desktop: true
            },
            OPTIONS: {
              mobile: true,
              desktop: true
            },
            SUMMARY: {
              mobile: true,
              desktop: true
            }
          },
          autoIntelRPOCode: '1SD',
          brandItemCode: 'CACT501',
        },
        sport: {
          configurationId: 'ct5sport01',
          name: {
            en: 'CT5 - Sport',
            ar: 'CT5 - Sport'
          },
          description: {
            en: 'CT5 Sport',
            ar: 'CT5 Sport'
          },
          drivetrain: '',
          trim: 'Sport',
          highlights: [
            {
              en: 'Available Technology Package',
              ar: 'حزمة التكنولوجيا المتاحة'
            },
            {
              en: 'Available Platinum Package',
              ar: 'حزمة البلاتينيوم المتاحة'
            }
          ],
          specs: [],
          image: 'images/2384/variant_ct5sport.png',
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            LBP: 0,
            default: 0,
          },
          index: 3,
          isDefault: false,
          ar: {
            enable: false,
            redirection: false
          },
          toggleTabs: {
            CONFIG: {
              mobile: false,
              desktop: false
            },
            MODEL: {
              mobile: true,
              desktop: true
            },
            EXTERIOR: {
              mobile: true,
              desktop: true
            },
            INTERIOR: {
              mobile: true,
              desktop: true
            },
            OPTIONS: {
              mobile: true,
              desktop: true
            },
            SUMMARY: {
              mobile: true,
              desktop: true
            }
          },
          autoIntelRPOCode: '1SE',
          brandItemCode: 'CACT502',
        }
      },
      backgrounds: {
        g0ZA968_RpUd: {
          image: 'images/2384/gulf_house_2.png',
          title: {
            en: 'Landscape 1',
            ar: 'المشهد الأول'
          }
        },
        g0ZA968_RpUe: {
          image: 'images/2384/CitySample_2.png',
          title: {
            en: 'Landscape 2',
            ar: 'المشهد الثاني'
          }
        }
      },
      ambientLighting: {},
      colors: {
        interior: {
          '03wk11dwf99s': {
            label: {
              en: 'Jet Black full semi-aniline leather seats with Jet Black accents',
              ar: 'مقاعد من جلد Semi-Aniline الكامل بلون Jet Black مع لمسات باللون الأسود Jet Black'
            },
            image: 'images/2384/Blackwing_Jet_Black_Semi_Aniline_HMR.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HMR',
            brandItemCode: 'IN50',
          },
          j50tispotnihpo: {
            label: {
              en: 'Natural Tan full semi-aniline leather seats with Jet Black accents',
              ar: 'مقاعد من جلد Semi-Aniline الكامل بلون Natural Tan مع لمسات باللون الأسود Jet Black'
            },
            image: 'images/2384/Blackwing_Natural_Tan_Semi_Aniline_HJC.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HJC',
            brandItemCode: 'IN61',
          },
          j5jjtistnihpo: {
            label: {
              en: 'Sky Cool Gray full semi-aniline leather seats with Jet Black accents',
              ar: 'مقاعد من جلد Semi-Aniline الكامل بلون Sky Cool Gray مع لمسات باللون الأسود Jet Black'
            },
            image: 'images/2384/Blackwing_Sky_Cool_Gray_Semi_Aniline_HJD.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 2,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HJD',
            brandItemCode: 'IN77',
          },
          j90d0tistnihpo: {
            label: {
              en: 'Jet Black leather seating surfaces with Jet Black accents',
              ar: 'أسطح مقاعد جلدية بلون Jet Black مع لمسات باللون الأسود Jet Black'
            },
            image: 'images/2384/Blackwing_Jet_Black_Leather_Seat_HGM.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 3,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HGM',
            brandItemCode: 'IN52',
          },
          j340d0tistnihpo: {
            label: {
              en: 'Sky Cool Gray leather seating surfaces with Jet Black accents',
              ar: 'أسطح مقاعد جلدية بلون Sky Cool Gray مع لمسات باللون الأسود Jet Black'
            },
            image: 'images/2384/Blackwing_Sky_Cool_Gray_Leather_Seat_HEB.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 4,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HEB',
            brandItemCode: 'IN80',
          },
          intBlackwingJetBlackPerformance6269: {
            label: {
              en: 'Jet Black performance leather seating surfaces with Jet Black accents',
              ar: 'أسطح مقاعد جلدية عالية الأداء بلون Jet Black مع لمسات باللون الأسود Jet Black'
            },
            image: 'images/2384/Blackwing_Jet_Black_Leather_Seat_Performance_HEA.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 5,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HEA',
          },
          intVSeriesJetBlack6966: {
            // Real swatch (GM code HGM), sourced from cadillac.com's CT5-V
            // configurator.
            label: {
              en: 'Jet Black Leather Seat',
              ar: 'مقعد جلدي Jet Black'
            },
            image: 'images/2384/VSeries_Jet_Black_Leather_Seat_HGM.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HGM',
          },
          intVSeries6955: {
            // Real swatch (GM code HEA) - CT5-V's real catalog models "high
            // performance" as a separate Seat Type option, not its own
            // interior color, so this is the closest real Jet Black leather
            // match (a second/premium Jet Black code) rather than an exact one.
            label: {
              en: 'Jet Black Leather High Performance Seat',
              ar: 'مقعد جلدي Jet Black عالي الأداء'
            },
            image: 'images/2384/VSeries_Jet_Black_Leather_High_Performance_Seat_HEA.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HEA',
          },
          intVSeries6965: {
            // Real swatch (GM code HND) - not offered on CT5-V's real
            // catalog, reused from Sport's Whisper Beige (same real color).
            label: {
              en: 'Whisper Beige Leather Seat',
              ar: 'مقعد جلدي Whisper Beige'
            },
            image: 'images/2384/Whisper_Beige_Leather_Seat_HND.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 2,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HND',
          },
          intVSeriesPlatinum6964: {
            // Real swatch (GM code HZK) - not offered on CT5-V's real
            // catalog, reused from Premium Luxury/Sport's Sedona Sauvage
            // (same real color).
            label: {
              en: 'Sedona Sauvage Semi Aniline Leather Seat (Platinum Package)',
              ar: 'مقعد جلدي Semi-Aniline من طراز Sedona Sauvage (حزمة البلاتينيوم)'
            },
            image: 'images/2384/Sedona_Sauvage_Semi_Aniline_Leather_Seat_HZK.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 3,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HZK',
          },
          intPremiumLuxuryDefault6940: {
            // Real swatch (GM code H1Y), sourced from cadillac.com's regular
            // CT5 configurator.
            label: {
              en: 'Jet Black',
              ar: 'Jet Black'
            },
            image: 'images/2384/PremiumLuxury_Jet_Black_Leather_Seat_H1Y.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'H1Y',
          },
          intPremiumLuxury6945: {
            // Real swatch (GM code HIK), sourced from cadillac.com.
            label: {
              en: 'Sahara Beige',
              ar: 'Sahara Beige'
            },
            image: 'images/2384/PremiumLuxury_Sahara_Beige_Leather_Seat_HIK.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HIK',
          },
          intPremiumLuxury6942: {
            // Real swatch (GM code HAV), sourced from cadillac.com.
            label: {
              en: 'Maple Sugar',
              ar: 'Maple Sugar'
            },
            image: 'images/2384/PremiumLuxury_Maple_Sugar_Leather_Seat_HAV.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 2,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HAV',
          },
          intPremiumLuxury6958: {
            // Real swatch (GM code HZK), sourced from cadillac.com.
            label: {
              en: 'Sedona Sauvage',
              ar: 'Sedona Sauvage'
            },
            image: 'images/2384/Sedona_Sauvage_Semi_Aniline_Leather_Seat_HZK.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 3,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HZK',
          },
          intSportDefault6959: {
            // "Inteluxe" is a real GM seating-material name, not a typo.
            // Real swatch (GM code HXR), sourced from cadillac.com's Sport
            // trim configurator.
            label: {
              en: 'Jet Black Inteluxe seats',
              ar: 'Jet Black مع مقاعد Inteluxe'
            },
            image: 'images/2384/Sport_Jet_Black_Inteluxe_Seat_HXR.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HXR',
          },
          intSport6938: {
            // Real swatch (GM code H2X), sourced from cadillac.com.
            label: {
              en: 'Jet Black Leather seats',
              ar: 'Jet Black مع مقاعد بأسطح جلدية'
            },
            image: 'images/2384/Sport_Jet_Black_Leather_Seat_H2X.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'H2X',
          },
          intSport6961: {
            // Real swatch (GM code HND), sourced from cadillac.com.
            label: {
              en: 'Whisper Beige',
              ar: 'Whisper Beige'
            },
            image: 'images/2384/Whisper_Beige_Leather_Seat_HND.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 2,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HND',
          },
          intSportPlatinum6968: {
            // Real swatch (GM code HZK), sourced from cadillac.com.
            label: {
              en: 'Sedona Sauvage',
              ar: 'Sedona Sauvage'
            },
            image: 'images/2384/Sedona_Sauvage_Semi_Aniline_Leather_Seat_HZK.jpg',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 3,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HZK',
          }
        },
        exterior: {
          '30ja6fs1si26': {
            label: {
              en: 'Black Raven',
              ar: 'أسود Raven'
            },
            image: 'images/2384/Black_Raven_GBA.jpg',
            usdz: 'black',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Black_Raven_GBA.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GBA',
            brandItemCode: 'EX23',
          },
          '1d0y9evbmngc': {
            label: {
              en: 'Deep Space Metallic',
              ar: 'Deep Space معدني'
            },
            image: 'images/2384/Deep_Space_Metallic_GAI.jpg',
            usdz: 'silver',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Deep_Space_Metallic_GAI.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GAI',
            brandItemCode: 'EX69',
          },
          mwsv1fnhg5wz: {
            label: {
              en: 'Typhoon Metallic',
              ar: 'Typhoon معدني'
            },
            image: 'images/2384/Typhoon_Metallic_GBW.jpg',
            usdz: 'red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 2,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Typhoon_Metallic_GBW.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GBW',
            brandItemCode: 'EX96',
          },
          onwrm9wz90ia: {
            label: {
              en: 'Radiant Red Tintcoat',
              ar: 'أحمر ساطع بطبقتين'
            },
            image: 'images/2384/Radiant_Red_Tintcoat_GNT.jpg',
            usdz: 'white',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 3,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Radiant_Red_Tintcoat_GNT.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GNT',
            brandItemCode: 'EX03',
          },
          bpsnuu0maoxi: {
            label: {
              en: 'Summit white',
              ar: 'أبيض Summit'
            },
            image: 'images/2384/Summit_White_GAZ.jpg',
            usdz: 'blue',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 4,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Summit_White_GAZ.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GAZ',
            brandItemCode: 'EX01',
          },
          bpffsnuu0maoxi: {
            label: {
              en: 'Coastal blue metallic',
              ar: 'أزرق Coastal معدني'
            },
            image: 'images/2384/Coastal_Blue_Metallic_GJV.jpg',
            usdz: 'blue',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 5,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Coastal_Blue_Metallic_GJV.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GJV',
            brandItemCode: 'EX24',
          },
          extVSeriesDefault6930: {
            // Real swatch (GM code GAI), sourced from cadillac.com's CT5-V
            // configurator - identical file already used by Blackwing's own
            // Deep Space Metallic entry.
            label: { en: 'Deep Space Metallic', ar: 'Deep Space معدني' },
            image: 'images/2384/Deep_Space_Metallic_GAI.jpg',
            usdz: 'black',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 0,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Deep_Space_Metallic_GAI.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GAI',
            brandItemCode: 'EX69',
          },
          extVSeries6931: {
            // Real swatch (GM code GBW), sourced from cadillac.com.
            label: { en: 'Typhoon Metallic', ar: 'Typhoon معدني' },
            image: 'images/2384/Typhoon_Metallic_GBW.jpg',
            usdz: 'silver',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 1,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Typhoon_Metallic_GBW.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GBW',
            brandItemCode: 'EX96',
          },
          extVSeries6937: {
            // Real swatch (GM code GAZ), sourced from cadillac.com.
            label: { en: 'Summit White', ar: 'أبيض Summit' },
            image: 'images/2384/Summit_White_GAZ.jpg',
            usdz: 'red',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 2,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Summit_White_GAZ.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GAZ',
            brandItemCode: 'EX01',
          },
          extVSeries6946: {
            // Real swatch (GM code GJV), sourced from cadillac.com.
            label: { en: 'Coastal Blue Metallic', ar: 'أزرق Coastal معدني' },
            image: 'images/2384/Coastal_Blue_Metallic_GJV.jpg',
            usdz: 'white',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 3,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Coastal_Blue_Metallic_GJV.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GJV',
            brandItemCode: 'EX24',
          },
          extVSeries6939: {
            // Real swatch (GM code GBA), sourced from cadillac.com.
            label: { en: 'Black Raven', ar: 'أسود Raven' },
            image: 'images/2384/Black_Raven_GBA.jpg',
            usdz: 'blue',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 4,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Black_Raven_GBA.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GBA',
            brandItemCode: 'EX23',
          },
          extVSeries6943: {
            // Real swatch (GM code GNT), sourced from cadillac.com.
            label: { en: 'Radiant Red Tintcoat', ar: 'أحمر ساطع بطبقتين' },
            image: 'images/2384/Radiant_Red_Tintcoat_GNT.jpg',
            usdz: 'blue',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 5,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Radiant_Red_Tintcoat_GNT.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GNT',
            brandItemCode: 'EX03',
          },
          extVSeries6952: {
            // Real swatch (GM code G4J) - only offered on the regular CT5
            // (Premium Luxury/Sport) configurator, not CT5-V, but it's the
            // same real paint so reused here for V_Series too.
            label: { en: 'Vibrant White Tricoat', ar: 'أبيض Vibrant بثلاث طبقات' },
            image: 'images/2384/Vibrant_White_Tricoat_G4J.jpg',
            usdz: 'silver',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 6,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Vibrant_White_Tricoat_G4J.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'G4J',
            brandItemCode: 'EX97',
          },
          extVSeries6951: {
            // Real swatch (GM code GXD), sourced from cadillac.com.
            label: { en: 'Argent Silver Metallic', ar: 'فضي Argent معدني' },
            image: 'images/2384/Argent_Silver_Metallic_GXD.jpg',
            usdz: 'black',
            price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
            index: 7,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2384/Argent_Silver_Metallic_GXD.jpg',
            hasQuantity: false,
            autoIntelRPOCode: 'GXD',
            brandItemCode: 'EX26',
          }
        }
      },
      features: {
        '50fyijsa8h88': {
          label: {
            en: 'Exterior Design',
            ar: 'التصميم الخارجي'
          },
          image: 'images/2384/ct5bw_Exterior_Design.jpg',
          title: {
            en: 'Exterior Design',
            ar: 'التصميم الخارجي'
          },
          desc: {
            en: 'Artful Aerodynamics',
            ar: 'ديناميكية هوائية متقنة'
          },
          type: 'exterior'
        },
        zarbo501dlfo: {
          label: {
            en: 'Front grille',
            ar: 'الشبك الأمامي'
          },
          image: 'images/2384/ct5bw_Front_grille.jpg',
          title: {
            en: 'Front grille',
            ar: 'الشبك الأمامي'
          },
          desc: {
            en: 'Performance grille and front fascia with aero ground effects and front fenders',
            ar: 'شبك أمامي رياضي وواجهة أمامية مع عناصر ديناميكية هوائية ورفارف أمامية'
          },
          type: 'exterior'
        },
        '1e0q63itjg52': {
          label: {
            en: 'Carbon Fiber lower spliters',
            ar: 'مشتتات هواء سفلية من ألياف الكربون'
          },
          image: 'images/2384/ct5bw_Carbon_Fiber_lower_spliters.jpg',
          title: {
            en: 'Carbon Fiber lower spliters',
            ar: 'مشتتات هواء سفلية من ألياف الكربون'
          },
          desc: {
            en: '',
            ar: ''
          },
          type: 'exterior'
        },
        sdkeibj4zedx: {
          label: {
            en: 'Infotainment screen',
            ar: 'شاشة المعلومات والترفيه'
          },
          image: 'images/2384/ct5bw_Infotainment_screen.jpg',
          title: {
            en: 'Infotainment screen',
            ar: 'شاشة المعلومات والترفيه'
          },
          desc: {
            en: '33" diagonal advanced LED display',
            ar: 'شاشة LED متطورة قياس 33 بوصة'
          },
          type: 'interior'
        },
        wfyhlnfxcntc: {
          label: {
            en: 'Sound System',
            ar: 'النظام الصوتي'
          },
          image: 'images/2384/ct5bw_Sound_System.jpg',
          title: {
            en: 'Sound System',
            ar: 'النظام الصوتي'
          },
          desc: {
            en: 'AKG Premium Audio',
            ar: 'نظام AKG Premium الصوتي'
          },
          type: 'interior'
        },
        ja3opivostgzo4: {
          label: {
            en: 'Steering Wheel',
            ar: 'عجلة القيادة'
          },
          image: 'images/2384/ct5bw_Steering_Wheel.jpg',
          title: {
            en: 'Steering Wheel',
            ar: 'عجلة القيادة'
          },
          desc: {
            en: 'Heated Steering wheel',
            ar: 'عجلة قيادة مدفأة'
          },
          type: 'interior'
        },
        '9v7g6wt62yu6': {
          label: {
            en: 'Charging',
            ar: 'الشحن'
          },
          image: 'images/2384/ct5bw_Charging.jpg',
          title: {
            en: 'Charging',
            ar: 'الشحن'
          },
          desc: {
            en: 'Wireless charging',
            ar: 'شحن لاسلكي للهاتف'
          },
          type: 'interior'
        },
        g6h9z7ho9usu: {
          label: {
            en: 'Ambient lighting',
            ar: 'الإضاءة المحيطية'
          },
          image: 'images/2384/ct5bw_Ambient_Lighting.jpg',
          title: {
            en: 'Ambient lighting',
            ar: 'الإضاءة المحيطية'
          },
          desc: {
            en: 'LED ambient lighting with 126 colours customization',
            ar: 'إضاءة LED محيطية مع إمكانية تخصيص 126 لوناً'
          },
          type: 'interior'
        },
        ja3evostgzo4: {
          label: {
            en: 'Driver Mode selector',
            ar: 'محدد وضعية القيادة'
          },
          image: 'images/2384/ct5bw_Driver_Mode_selector.jpg',
          title: {
            en: 'Driver Mode selector',
            ar: 'محدد وضعية القيادة'
          },
          desc: {
            en: 'Choose between different drive mode available',
            ar: 'اختر من بين أوضاع القيادة المتوفرة'
          },
          type: 'interior'
        },
        featBlackwingEngine: {
          label: {
            en: 'Powerfull Engines',
            ar: 'محركات قوية'
          },
          image: 'images/2384/ct5bw_Engine.jpg',
          title: {
            en: 'Powerfull Engines',
            ar: 'محركات قوية'
          },
          desc: {
            en: 'Powerfull Engines',
            ar: 'محركات قوية'
          },
          type: 'exterior'
        },
        featBlackwingBrakes: {
          label: {
            en: 'Brembo Performance Brakes',
            ar: 'مكابح Brembo عالية الأداء'
          },
          image: 'images/2384/ct5bw_Brakes.jpg',
          title: {
            en: 'Brembo Performance Brakes',
            ar: 'مكابح Brembo عالية الأداء'
          },
          desc: {
            en: 'Brembo Performance Brakes',
            ar: 'مكابح Brembo عالية الأداء'
          },
          type: 'exterior'
        },
        featBlackwingHUD: {
          label: {
            en: 'Heads-Up Display',
            ar: 'شاشة العرض الأمامية'
          },
          image: 'images/2384/ct5bw_HUD.jpg',
          title: {
            en: 'Heads-Up Display',
            ar: 'شاشة العرض الأمامية'
          },
          desc: {
            en: 'Heads-Up Display',
            ar: 'شاشة العرض الأمامية'
          },
          type: 'interior'
        },
        featBlackwingSteeringWheelVMode: {
          label: {
            en: 'Performance Steering Wheel with V-Mode button',
            ar: 'عجلة قيادة رياضية بزر V-Mode'
          },
          image: 'images/2384/ct5bw_Steering_Wheel_V_Mode.jpg',
          title: {
            en: 'Performance Steering Wheel with V-Mode button',
            ar: 'عجلة قيادة رياضية بزر V-Mode'
          },
          desc: {
            en: 'Performance Steering Wheel with V-Mode button',
            ar: 'عجلة قيادة رياضية بزر V-Mode'
          },
          type: 'interior'
        },
        featVSeriesExteriorDesign: { label: { en: 'Exterior Design', ar: 'التصميم الخارجي' }, image: 'images/2384/VSeries_Cinematic_Exterior_Design.jpg', title: { en: 'Exterior Design', ar: 'التصميم الخارجي' }, desc: { en: 'Artful Aerodynamics', ar: 'ديناميكية هوائية متقنة' }, type: 'exterior' },
        featPremiumLuxuryExteriorDesign: { label: { en: 'Exterior Design', ar: 'التصميم الخارجي' }, image: 'images/2384/PremiumLuxury_Cinematic_Exterior_Design.jpg', title: { en: 'Exterior Design', ar: 'التصميم الخارجي' }, desc: { en: 'Artful Aerodynamics', ar: 'ديناميكية هوائية متقنة' }, type: 'exterior' },
        featSportExteriorDesign: { label: { en: 'Exterior Design', ar: 'التصميم الخارجي' }, image: 'images/2384/Sport_Cinematic_Exterior_Design.jpg', title: { en: 'Exterior Design', ar: 'التصميم الخارجي' }, desc: { en: 'Artful Aerodynamics', ar: 'ديناميكية هوائية متقنة' }, type: 'exterior' },
        featVSeriesFrontGrille: { label: { en: 'Front grille', ar: 'الشبك الأمامي' }, image: 'images/2384/VSeries_Cinematic_Front_grille.jpg', title: { en: 'Front grille', ar: 'الشبك الأمامي' }, desc: { en: 'Performance grille and front fascia with aero ground effects and front fenders', ar: 'شبك أمامي رياضي وواجهة أمامية مع عناصر ديناميكية هوائية ورفارف أمامية' }, type: 'exterior' },
        featPremiumLuxuryFrontGrille: { label: { en: 'Front grille', ar: 'الشبك الأمامي' }, image: 'images/2384/PremiumLuxury_Cinematic_Front_grille.jpg', title: { en: 'Front grille', ar: 'الشبك الأمامي' }, desc: { en: 'Performance grille and front fascia with aero ground effects and front fenders', ar: 'شبك أمامي رياضي وواجهة أمامية مع عناصر ديناميكية هوائية ورفارف أمامية' }, type: 'exterior' },
        featSportFrontGrille: { label: { en: 'Front grille', ar: 'الشبك الأمامي' }, image: 'images/2384/Sport_Cinematic_Front_grille.jpg', title: { en: 'Front grille', ar: 'الشبك الأمامي' }, desc: { en: 'Performance grille and front fascia with aero ground effects and front fenders', ar: 'شبك أمامي رياضي وواجهة أمامية مع عناصر ديناميكية هوائية ورفارف أمامية' }, type: 'exterior' },
        featVSeriesInfotainmentScreen: { label: { en: 'Infotainment screen', ar: 'شاشة المعلومات والترفيه' }, image: 'images/2384/VSeries_Cinematic_Infotainment_screen.jpg', title: { en: 'Infotainment screen', ar: 'شاشة المعلومات والترفيه' }, desc: { en: '33" diagonal advanced LED display', ar: 'شاشة LED متطورة قياس 33 بوصة' }, type: 'interior' },
        featPremiumLuxuryInfotainmentScreen: { label: { en: 'Infotainment screen', ar: 'شاشة المعلومات والترفيه' }, image: 'images/2384/PremiumLuxury_Cinematic_Infotainment_screen.jpg', title: { en: 'Infotainment screen', ar: 'شاشة المعلومات والترفيه' }, desc: { en: '33" diagonal advanced LED display', ar: 'شاشة LED متطورة قياس 33 بوصة' }, type: 'interior' },
        featSportInfotainmentScreen: { label: { en: 'Infotainment screen', ar: 'شاشة المعلومات والترفيه' }, image: 'images/2384/Sport_Cinematic_Infotainment_screen.jpg', title: { en: 'Infotainment screen', ar: 'شاشة المعلومات والترفيه' }, desc: { en: '33" diagonal advanced LED display', ar: 'شاشة LED متطورة قياس 33 بوصة' }, type: 'interior' },
        featVSeriesSoundSystem: { label: { en: 'Sound System', ar: 'النظام الصوتي' }, image: 'images/2384/VSeries_Cinematic_Sound_System.jpg', title: { en: 'Sound System', ar: 'النظام الصوتي' }, desc: { en: 'AKG Premium Audio', ar: 'نظام AKG Premium الصوتي' }, type: 'interior' },
        featPremiumLuxurySoundSystem: { label: { en: 'Sound System', ar: 'النظام الصوتي' }, image: 'images/2384/PremiumLuxury_Cinematic_Sound_System.jpg', title: { en: 'Sound System', ar: 'النظام الصوتي' }, desc: { en: 'AKG Premium Audio', ar: 'نظام AKG Premium الصوتي' }, type: 'interior' },
        featSportSoundSystem: { label: { en: 'Sound System', ar: 'النظام الصوتي' }, image: 'images/2384/Sport_Cinematic_Sound_System.jpg', title: { en: 'Sound System', ar: 'النظام الصوتي' }, desc: { en: 'AKG Premium Audio', ar: 'نظام AKG Premium الصوتي' }, type: 'interior' },
        featVSeriesSteeringWheel: { label: { en: 'Steering Wheel', ar: 'عجلة القيادة' }, image: 'images/2384/VSeries_Cinematic_Steering_Wheel.jpg', title: { en: 'Steering Wheel', ar: 'عجلة القيادة' }, desc: { en: 'Heated Steering wheel', ar: 'عجلة قيادة مدفأة' }, type: 'interior' },
        featPremiumLuxurySteeringWheel: { label: { en: 'Steering Wheel', ar: 'عجلة القيادة' }, image: 'images/2384/PremiumLuxury_Cinematic_Steering_Wheel.jpg', title: { en: 'Steering Wheel', ar: 'عجلة القيادة' }, desc: { en: 'Heated Steering wheel', ar: 'عجلة قيادة مدفأة' }, type: 'interior' },
        featSportSteeringWheel: { label: { en: 'Steering Wheel', ar: 'عجلة القيادة' }, image: 'images/2384/Sport_Cinematic_Steering_Wheel.jpg', title: { en: 'Steering Wheel', ar: 'عجلة القيادة' }, desc: { en: 'Heated Steering wheel', ar: 'عجلة قيادة مدفأة' }, type: 'interior' },
        featVSeriesCharging: { label: { en: 'Charging', ar: 'الشحن' }, image: 'images/2384/VSeries_Cinematic_Charging.jpg', title: { en: 'Charging', ar: 'الشحن' }, desc: { en: 'Wireless charging', ar: 'شحن لاسلكي للهاتف' }, type: 'interior' },
        featPremiumLuxuryCharging: { label: { en: 'Charging', ar: 'الشحن' }, image: 'images/2384/PremiumLuxury_Cinematic_Charging.jpg', title: { en: 'Charging', ar: 'الشحن' }, desc: { en: 'Wireless charging', ar: 'شحن لاسلكي للهاتف' }, type: 'interior' },
        featSportCharging: { label: { en: 'Charging', ar: 'الشحن' }, image: 'images/2384/Sport_Cinematic_Charging.jpg', title: { en: 'Charging', ar: 'الشحن' }, desc: { en: 'Wireless charging', ar: 'شحن لاسلكي للهاتف' }, type: 'interior' },
        featVSeriesAmbientLighting: { label: { en: 'Ambient lighting', ar: 'الإضاءة المحيطية' }, image: 'images/2384/VSeries_Cinematic_Ambient_Lighting.jpg', title: { en: 'Ambient lighting', ar: 'الإضاءة المحيطية' }, desc: { en: 'LED ambient lighting with 126 colours customization', ar: 'إضاءة LED محيطية مع إمكانية تخصيص 126 لوناً' }, type: 'interior' },
        featPremiumLuxuryAmbientLighting: { label: { en: 'Ambient lighting', ar: 'الإضاءة المحيطية' }, image: 'images/2384/PremiumLuxury_Cinematic_Ambient_Lighting.jpg', title: { en: 'Ambient lighting', ar: 'الإضاءة المحيطية' }, desc: { en: 'LED ambient lighting with 126 colours customization', ar: 'إضاءة LED محيطية مع إمكانية تخصيص 126 لوناً' }, type: 'interior' },
        featSportAmbientLighting: { label: { en: 'Ambient lighting', ar: 'الإضاءة المحيطية' }, image: 'images/2384/Sport_Cinematic_Ambient_Lighting.jpg', title: { en: 'Ambient lighting', ar: 'الإضاءة المحيطية' }, desc: { en: 'LED ambient lighting with 126 colours customization', ar: 'إضاءة LED محيطية مع إمكانية تخصيص 126 لوناً' }, type: 'interior' },
        featVSeriesDriverModeSelector: { label: { en: 'Driver Mode selector', ar: 'محدد وضعية القيادة' }, image: 'images/2384/VSeries_Cinematic_Driver_Mode_selector.jpg', title: { en: 'Driver Mode selector', ar: 'محدد وضعية القيادة' }, desc: { en: 'Choose between different drive mode available', ar: 'اختر من بين أوضاع القيادة المتوفرة' }, type: 'interior' },
        featPremiumLuxuryDriverModeSelector: { label: { en: 'Driver Mode selector', ar: 'محدد وضعية القيادة' }, image: 'images/2384/PremiumLuxury_Cinematic_Driver_Mode_selector.jpg', title: { en: 'Driver Mode selector', ar: 'محدد وضعية القيادة' }, desc: { en: 'Choose between different drive mode available', ar: 'اختر من بين أوضاع القيادة المتوفرة' }, type: 'interior' },
        featSportDriverModeSelector: { label: { en: 'Driver Mode selector', ar: 'محدد وضعية القيادة' }, image: 'images/2384/Sport_Cinematic_Driver_Mode_selector.jpg', title: { en: 'Driver Mode selector', ar: 'محدد وضعية القيادة' }, desc: { en: 'Choose between different drive mode available', ar: 'اختر من بين أوضاع القيادة المتوفرة' }, type: 'interior' }
      },
      accessories: {
        accVSeriesVariantParts: { label: { en: 'V-Series Body Kit', ar: 'طقم هيكل V-Series' }, image: '', category: { en: 'Variant Parts', ar: 'أجزاء الفئة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accPremiumLuxuryVariantParts: { label: { en: 'Premium Luxury Body Kit', ar: 'طقم هيكل Premium Luxury' }, image: '', category: { en: 'Variant Parts', ar: 'أجزاء الفئة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accSportVariantParts: { label: { en: 'Sport Body Kit', ar: 'طقم هيكل Sport' }, image: '', category: { en: 'Variant Parts', ar: 'أجزاء الفئة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accVSeriesSunroofOff: { label: { en: 'Sunroof (off)', ar: 'فتحة السقف (متوقفة)' }, image: '', category: { en: 'Roof Options', ar: 'خيارات السقف' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accVSeriesSunroofOn: { label: { en: 'UltraView power sunroof', ar: 'فتحة سقف كهربائية UltraView' }, image: '', category: { en: 'Roof Options', ar: 'خيارات السقف' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'C3U' },
        accVSeriesSeatbeltDefault: { label: { en: 'Seatbelt (default)', ar: 'حزام الأمان (افتراضي)' }, image: '', category: { en: 'Seat Belt', ar: 'حزام الأمان' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accVSeriesSeatbeltRed: { label: { en: 'Torch Red seat belt color', ar: 'لون حزام الأمان Torch Red' }, image: 'images/2384/VSeries_Optional_Seatbelt_Red.jpg', category: { en: 'Seat Belt', ar: 'حزام الأمان' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: '709' },
        accVSeriesBrakesDefault: { label: { en: 'Brake calipers (default)', ar: 'فرامل (افتراضي)' }, image: '', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accVSeriesBrakesBlue: { label: { en: 'Blue brake calipers', ar: 'فرامل زرقاء' }, image: 'images/2384/VSeries_Optional_Brakes_J56_Blue.jpg', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'J6B' },
        accVSeriesBrakesRed: { label: { en: 'Red brake calipers', ar: 'فرامل حمراء' }, image: 'images/2384/VSeries_Optional_Brakes_J56_Red.jpg', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'J6F' },
        accVSeriesAlloy57M: { label: { en: '19" aluminum wheels with Satin Graphite finish', ar: 'عجلات ألمنيوم 19 بوصة بلمسة Satin Graphite' }, image: '', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: '57M' },
        accVSeriesAlloyQB0: { label: { en: '19" aluminum wheels with Pearl Nickel finish', ar: 'عجلات ألمنيوم 19 بوصة بلمسة Pearl Nickel' }, image: 'images/2384/VSeries_Optional_Alloy_QB0.jpg', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'QB0' },
        accVSeriesTechnologyOff: { label: { en: 'Technology Package content (off)', ar: 'محتوى حزمة التكنولوجيا (متوقف)' }, image: '', category: { en: 'Technology', ar: 'التكنولوجيا' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accVSeriesTechnologyOn: { label: { en: 'Technology Package content (on)', ar: 'محتوى حزمة التكنولوجيا (مفعّل)' }, image: '', category: { en: 'Technology', ar: 'التكنولوجيا' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'CWN' },
        accPremiumLuxurySunroofOff: { label: { en: 'Sunroof (off)', ar: 'فتحة السقف (متوقفة)' }, image: '', category: { en: 'Roof Options', ar: 'خيارات السقف' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accPremiumLuxurySunroofOn: { label: { en: 'UltraView power sunroof', ar: 'فتحة سقف كهربائية UltraView' }, image: 'images/2384/PremiumLuxury_Optional_W_Sunroof.jpg', category: { en: 'Roof Options', ar: 'خيارات السقف' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'C3U' },
        accPremiumLuxuryBrakesDefault: { label: { en: 'Brake calipers (default)', ar: 'فرامل (افتراضي)' }, image: '', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accPremiumLuxuryAlloyQE1: { label: { en: '18" alloy wheels with Manoogian Silver finish', ar: 'عجلات سبيكة 18 بوصة بلمسة Manoogian Silver' }, image: '', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'QE1' },
        accPremiumLuxuryAlloyQ84: { label: { en: '19" alloy wheels with Diamond Cut/Midnight Silver finish', ar: 'عجلات سبيكة 19 بوصة بلمسة Diamond Cut/Midnight Silver' }, image: 'images/2384/PremiumLuxury_Optional_Alloy_Q84.jpg', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'Q84' },
        accPremiumLuxuryTechnologyOff: { label: { en: 'Technology Package content (off)', ar: 'محتوى حزمة التكنولوجيا (متوقف)' }, image: '', category: { en: 'Technology', ar: 'التكنولوجيا' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accPremiumLuxuryTechnologyOn: { label: { en: 'Technology Package content (on)', ar: 'محتوى حزمة التكنولوجيا (مفعّل)' }, image: '', category: { en: 'Technology', ar: 'التكنولوجيا' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'CWN' },
        accSportSunroofOff: { label: { en: 'Sunroof (off)', ar: 'فتحة السقف (متوقفة)' }, image: '', category: { en: 'Roof Options', ar: 'خيارات السقف' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accSportSunroofOn: { label: { en: 'UltraView power sunroof', ar: 'فتحة سقف كهربائية UltraView' }, image: 'images/2384/Sport_Optional_W_Sunroof.jpg', category: { en: 'Roof Options', ar: 'خيارات السقف' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'C3U' },
        accSportBrakesDefault: { label: { en: 'Brake calipers (default)', ar: 'فرامل (افتراضي)' }, image: '', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accSportBrakesBlue: { label: { en: 'Blue brake calipers', ar: 'فرامل زرقاء' }, image: 'images/2384/Sport_Optional_Brakes_J56_Blue.jpg', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'J6B' },
        accSportBrakesRed: { label: { en: 'Red brake calipers', ar: 'فرامل حمراء' }, image: 'images/2384/Sport_Optional_Brakes_J56_Red.jpg', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'J6F' },
        accSportAlloyQ83: { label: { en: '19" alloy wheels with Pearl Nickel finish', ar: 'عجلات سبيكة 19 بوصة بلمسة Pearl Nickel' }, image: '', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'Q83' },
        accSportAlloy57M: { label: { en: '19" aluminum wheels with Satin Graphite finish', ar: 'عجلات ألمنيوم 19 بوصة بلمسة Satin Graphite' }, image: 'images/2384/Sport_Optional_Alloy_57M.jpg', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: '57M' },
        accSportTechnologyOff: { label: { en: 'Technology Package content (off)', ar: 'محتوى حزمة التكنولوجيا (متوقف)' }, image: '', category: { en: 'Technology', ar: 'التكنولوجيا' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accSportTechnologyOn: { label: { en: 'Technology Package content (on)', ar: 'محتوى حزمة التكنولوجيا (مفعّل)' }, image: '', category: { en: 'Technology', ar: 'التكنولوجيا' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'CWN' },
        accBlackwingCaliperJ6HDefault: { label: { en: 'Brake calipers (default)', ar: 'فرامل (افتراضي)' }, image: '', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCaliperJ6HBlue: { label: { en: 'Blue brake calipers', ar: 'فرامل زرقاء' }, image: 'images/2384/Caliper_J6H_Blue.jpg', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCaliperJ6HRed: { label: { en: 'Red brake calipers', ar: 'فرامل حمراء' }, image: 'images/2384/Caliper_J6H_Red.jpg', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCaliperJ6HBronze: { label: { en: 'Bronze brake calipers', ar: 'فرامل برونزية' }, image: 'images/2384/Caliper_J6H_Bronze.jpg', category: { en: 'Brake Calipers', ar: 'ملاقط الفرامل' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCaliperJ57Blue: { label: { en: 'Blue brake calipers', ar: 'فرامل زرقاء' }, image: 'images/2384/Caliper_J57_Blue.jpg', category: { en: 'Carbon Ceramic Brakes with cross-drilled rotors', ar: 'مكابح سيراميك كربوني بأقراص مثقّبة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCaliperJ57Red: { label: { en: 'Red brake calipers', ar: 'فرامل حمراء' }, image: 'images/2384/Caliper_J57_Red.jpg', category: { en: 'Carbon Ceramic Brakes with cross-drilled rotors', ar: 'مكابح سيراميك كربوني بأقراص مثقّبة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCaliperJ57Bronze: { label: { en: 'Bronze brake calipers', ar: 'فرامل برونزية' }, image: 'images/2384/Caliper_J57_Bronze.jpg', category: { en: 'Carbon Ceramic Brakes with cross-drilled rotors', ar: 'مكابح سيراميك كربوني بأقراص مثقّبة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCarbonFiber1Off: { label: { en: 'Carbon Fiber 1 Package (off)', ar: 'حزمة ألياف الكربون 1 (متوقف)' }, image: '', category: { en: 'Carbon Fiber Packages', ar: 'حزم ألياف الكربون' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCarbonFiber1On: { label: { en: 'Carbon Fiber 1 Package', ar: 'حزمة ألياف الكربون 1' }, image: 'images/2384/W_Carbon_Fiber_1.jpg', category: { en: 'Carbon Fiber Packages', ar: 'حزم ألياف الكربون' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCarbonFiber2Off: { label: { en: 'Carbon Fiber 2 Package (off)', ar: 'حزمة ألياف الكربون 2 (متوقف)' }, image: '', category: { en: 'Carbon Fiber Packages', ar: 'حزم ألياف الكربون' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingCarbonFiber2On: { label: { en: 'Carbon Fiber 2 Package', ar: 'حزمة ألياف الكربون 2' }, image: 'images/2384/W_Carbon_Fiber_2.jpg', category: { en: 'Carbon Fiber Packages', ar: 'حزم ألياف الكربون' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart' },
        accBlackwingAlloyQ63: { label: { en: '19" alloy wheels (Q63)', ar: 'عجلات سبيكة 19 بوصة (Q63)' }, image: '', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'Q63' },
        accBlackwingAlloyQ61: { label: { en: '19" alloy wheels (Q61)', ar: 'عجلات سبيكة 19 بوصة (Q61)' }, image: 'images/2384/Alloy_Q61_19in.jpg', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'Q61' },
        accBlackwingAlloyRHL: { label: { en: '19" alloy wheels (RHL)', ar: 'عجلات سبيكة 19 بوصة (RHL)' }, image: 'images/2384/Alloy_RHL_19in.jpg', category: { en: 'Alloy Wheels', ar: 'عجلات السبيكة' }, price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }, cardType: 'cart', autoIntelRPOCode: 'RHL' }
      },
      packages: {
        pkgVSeriesTechnology: {
          label: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
          image: 'images/2384/Placeholder_VSeries_Technology_Package.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart',
          packageDescription: {
            en: 'The Technology Package adds advanced technology content to the CT5 V-Series.',
            ar: 'تضيف حزمة التكنولوجيا محتوى تقنيًا متقدمًا إلى CT5 V-Series.'
          },
          accessoryContent: [
            {
              accessoryDescription: { en: 'Heads-Up Display', ar: 'شاشة العرض الأمامية' },
              accessoryTitle: { en: 'Heads-Up Display', ar: 'شاشة العرض الأمامية' },
              image: 'images/2384/VSeries_TechPkg_HeadsUp_Display.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Illuminated Door Handles', ar: 'مقابض أبواب مضيئة' },
              accessoryTitle: { en: 'Illuminated Door Handles', ar: 'مقابض أبواب مضيئة' },
              image: 'images/2384/VSeries_TechPkg_Illuminated_Door_Handles.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Illuminating Front Sills with Cadillac Crest Logo', ar: 'عتبات أمامية مضيئة بشعار كاديلاك' },
              accessoryTitle: { en: 'Illuminating Front Sills with Cadillac Crest Logo', ar: 'عتبات أمامية مضيئة بشعار كاديلاك' },
              image: 'images/2384/VSeries_TechPkg_Illuminating_Front_Sills_with_Cadillac_Crest_Logo.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Premium headlamp system', ar: 'نظام مصابيح أمامية متطور' },
              accessoryTitle: { en: 'Premium headlamp system', ar: 'نظام مصابيح أمامية متطور' },
              image: 'images/2384/VSeries_TechPkg_Premium_headlamp_system.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Rear Camera Mirror', ar: 'مرآة الكاميرا الخلفية' },
              accessoryTitle: { en: 'Rear Camera Mirror', ar: 'مرآة الكاميرا الخلفية' },
              image: 'images/2384/VSeries_TechPkg_Rear_Camera_Mirror.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            }
          ],
          autoIntelRPOCode: 'CWN',
          brandItemCode: 'PA03',
        },
        pkgVSeriesPlatinum: {
          label: { en: 'Platinum Package', ar: 'حزمة البلاتينيوم' },
          image: 'images/2384/Placeholder_VSeries_Platinum_Package.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart',
          packageDescription: {
            en: 'The Platinum Package includes the Sedona Sauvage / Platinum interior color, the UltraView power sunroof, and the Technology Package.',
            ar: 'تشمل حزمة البلاتينيوم اللون الداخلي Sedona Sauvage / بلاتينيوم، وفتحة السقف الكهربائية UltraView، وحزمة التكنولوجيا.'
          },
          accessoryContent: [
            {
              accessoryDescription: { en: 'UltraView power sunroof', ar: 'فتحة سقف كهربائية UltraView' },
              accessoryTitle: { en: 'UltraView power sunroof', ar: 'فتحة سقف كهربائية UltraView' },
              image: 'images/2384/VSeries_PlatinumPkg_UltraView_Sunroof.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
              accessoryTitle: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
              image: 'images/2384/Placeholder_VSeries_Technology_Package.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Platinum interior color', ar: 'لون داخلي بلاتينيوم' },
              accessoryTitle: { en: 'Platinum interior color', ar: 'لون داخلي بلاتينيوم' },
              image: 'images/2384/VSeries_PlatinumPkg_Platinum_Interior_Color.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            }
          ],
          autoIntelRPOCode: 'ZRG'
        },
        pkgPremiumLuxuryTechnology: {
          label: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
          image: 'images/2384/Placeholder_VSeries_Technology_Package.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart',
          packageDescription: {
            en: 'The Technology Package adds advanced technology content to the CT5 Premium Luxury.',
            ar: 'تضيف حزمة التكنولوجيا محتوى تقنيًا متقدمًا إلى CT5 Premium Luxury.'
          },
          accessoryContent: [
            {
              accessoryDescription: { en: 'Heads-Up Display', ar: 'شاشة العرض الأمامية' },
              accessoryTitle: { en: 'Heads-Up Display', ar: 'شاشة العرض الأمامية' },
              image: 'images/2384/PremiumLuxury_TechPkg_HeadsUp_Display.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Illuminating Front Sills with Cadillac Crest Logo', ar: 'عتبات أمامية مضيئة بشعار كاديلاك' },
              accessoryTitle: { en: 'Illuminating Front Sills with Cadillac Crest Logo', ar: 'عتبات أمامية مضيئة بشعار كاديلاك' },
              image: 'images/2384/PremiumLuxury_TechPkg_Illuminating_Front_Sills_with_Cadillac_Crest_Logo.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Premium headlamp system', ar: 'نظام مصابيح أمامية متطور' },
              accessoryTitle: { en: 'Premium headlamp system', ar: 'نظام مصابيح أمامية متطور' },
              image: 'images/2384/PremiumLuxury_TechPkg_Premium_headlamp_system.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Rear Camera Mirror', ar: 'مرآة الكاميرا الخلفية' },
              accessoryTitle: { en: 'Rear Camera Mirror', ar: 'مرآة الكاميرا الخلفية' },
              image: 'images/2384/PremiumLuxury_TechPkg_Rear_Camera_Mirror.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            }
          ],
          autoIntelRPOCode: 'CWN',
          brandItemCode: 'PA03',
        },
        pkgPremiumLuxuryPlatinum: {
          label: { en: 'Platinum Package', ar: 'حزمة البلاتينيوم' },
          image: 'images/2384/Placeholder_VSeries_Platinum_Package.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart',
          packageDescription: {
            en: 'The Platinum Package includes the Sedona Sauvage interior color and the Technology Package.',
            ar: 'تشمل حزمة البلاتينيوم اللون الداخلي Sedona Sauvage وحزمة التكنولوجيا.'
          },
          accessoryContent: [
            {
              accessoryDescription: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
              accessoryTitle: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
              image: 'images/2384/Placeholder_VSeries_Technology_Package.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Sedona Sauvage interior color', ar: 'اللون الداخلي Sedona Sauvage' },
              accessoryTitle: { en: 'Sedona Sauvage interior color', ar: 'اللون الداخلي Sedona Sauvage' },
              image: 'images/2384/Sedona_Sauvage_Semi_Aniline_Leather_Seat_HZK.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            }
          ],
          autoIntelRPOCode: 'JSE'
        },
        pkgBlackwingCarbonFiber1: {
          label: { en: 'Carbon Fiber 1 Package', ar: 'حزمة ألياف الكربون 1' },
          image: 'images/2384/W_Carbon_Fiber_1.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart'
        },
        pkgBlackwingCarbonFiber2: {
          label: { en: 'Carbon Fiber 2 Package', ar: 'حزمة ألياف الكربون 2' },
          image: 'images/2384/W_Carbon_Fiber_2.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart'
        },
        pkgSportTechnology: {
          label: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
          image: 'images/2384/Placeholder_VSeries_Technology_Package.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart',
          packageDescription: {
            en: 'The Technology Package adds advanced technology content to the CT5 Sport.',
            ar: 'تضيف حزمة التكنولوجيا محتوى تقنيًا متقدمًا إلى CT5 Sport.'
          },
          accessoryContent: [
            {
              accessoryDescription: { en: 'Heads-Up Display', ar: 'شاشة العرض الأمامية' },
              accessoryTitle: { en: 'Heads-Up Display', ar: 'شاشة العرض الأمامية' },
              image: 'images/2384/Sport_TechPkg_HeadsUp_Display.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Illuminated Door Handles', ar: 'مقابض أبواب مضيئة' },
              accessoryTitle: { en: 'Illuminated Door Handles', ar: 'مقابض أبواب مضيئة' },
              image: 'images/2384/Sport_TechPkg_Illuminated_Door_Handles.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Illuminating Front Sills with Cadillac Crest Logo', ar: 'عتبات أمامية مضيئة بشعار كاديلاك' },
              accessoryTitle: { en: 'Illuminating Front Sills with Cadillac Crest Logo', ar: 'عتبات أمامية مضيئة بشعار كاديلاك' },
              image: 'images/2384/Sport_TechPkg_Illuminating_Front_Sills_with_Cadillac_Crest_Logo.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Premium headlamp system', ar: 'نظام مصابيح أمامية متطور' },
              accessoryTitle: { en: 'Premium headlamp system', ar: 'نظام مصابيح أمامية متطور' },
              image: 'images/2384/Sport_TechPkg_Premium_headlamp_system.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Rear Camera Mirror', ar: 'مرآة الكاميرا الخلفية' },
              accessoryTitle: { en: 'Rear Camera Mirror', ar: 'مرآة الكاميرا الخلفية' },
              image: 'images/2384/Sport_TechPkg_Rear_Camera_Mirror.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            }
          ],
          autoIntelRPOCode: 'CWN',
          brandItemCode: 'PA03',
        },
        pkgSportPlatinum: {
          label: { en: 'Platinum Package', ar: 'حزمة البلاتينيوم' },
          image: 'images/2384/Placeholder_VSeries_Platinum_Package.jpg',
          category: { en: 'Packages', ar: 'الحزم' },
          price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 },
          cardType: 'cart',
          packageDescription: {
            en: 'The Platinum Package includes the Sport Platinum interior color, the UltraView power sunroof, and the Technology Package.',
            ar: 'تشمل حزمة البلاتينيوم اللون الداخلي Sport بلاتينيوم، وفتحة السقف الكهربائية UltraView، وحزمة التكنولوجيا.'
          },
          accessoryContent: [
            {
              accessoryDescription: { en: 'UltraView power sunroof', ar: 'فتحة سقف كهربائية UltraView' },
              accessoryTitle: { en: 'UltraView power sunroof', ar: 'فتحة سقف كهربائية UltraView' },
              image: 'images/2384/Sport_Optional_W_Sunroof.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
              accessoryTitle: { en: 'Technology Package', ar: 'حزمة التكنولوجيا' },
              image: 'images/2384/Placeholder_VSeries_Technology_Package.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            },
            {
              accessoryDescription: { en: 'Platinum interior color', ar: 'لون داخلي بلاتينيوم' },
              accessoryTitle: { en: 'Platinum interior color', ar: 'لون داخلي بلاتينيوم' },
              image: 'images/2384/Sport_PlatinumPkg_Platinum_Interior_Color.jpg',
              price: { KSA: 0, UAE: 0, OMR: 0, BHD: 0, QAR: 0, JOD: 0, default: 0 }
            }
          ],
          autoIntelRPOCode: 'JSE'
        }
      },
      // Generic color<->package lock, read by src/hooks/useColorPackageLocks.ts.
      // Not part of the discover-sdk schema (same escape hatch already used for
      // backgroundVariantSkus above) - selecting intVSeriesPlatinum6964 auto-
      // applies pkgVSeriesPlatinum and vice versa; same for intSportPlatinum6968
      // and pkgSportPlatinum.
      colorPackageLocks: [
        { variantId: 'v_series', colorType: 'interior', colorId: 'intVSeriesPlatinum6964', packageId: 'pkgVSeriesPlatinum' },
        { variantId: 'sport', colorType: 'interior', colorId: 'intSportPlatinum6968', packageId: 'pkgSportPlatinum' }
      ],
      // Opts CT5 into ConfigPanel's per-category section rendering (same
      // mechanism Tahoe/2365 uses) - without this, accessories categorized
      // as anything other than the hardcoded 'Roof'/'Seats'/'Accessories'
      // fallbacks never render anywhere in the UI. Setting this list replaces
      // the hardcoded 'Roof' fallback entirely, hence 'Roof Options' is
      // listed here too.
      accessoryCategories: {
        exterior: ['Roof Options', 'Brake Calipers', 'Carbon Ceramic Brakes with cross-drilled rotors', 'Alloy Wheels'],
        interior: ['Seat Belt']
      },
      interactions: {
        ihmz2ch7lru2: {
          label: {
            en: 'Doors',
            ar: 'الأبواب'
          },
          type: 'interaction'
        },
        '53ehrrkf0yxy': {
          label: {
            en: 'Boot',
            ar: 'صندوق الأمتعة'
          },
          type: 'interaction'
        },
        rc1z7dwmbfif: {
          label: {
            en: 'Sunroof',
            ar: 'فتحة السقف'
          },
          type: 'interaction'
        },
        w3yjdzjao2i0: {
          label: {
            en: 'Headlight',
            ar: 'المصابيح الأمامية'
          },
          type: 'interaction'
        },
        toijdriu1av5: {
          label: {
            en: 'DRL',
            ar: 'مصابيح القيادة النهارية'
          },
          type: 'interaction'
        },
        g64qit5yzfp2: {
          label: {
            en: 'Taillight',
            ar: 'المصابيح الخلفية'
          },
          type: 'interaction'
        }
      },
      hotspots: {
        exteriorCamera: {
          title: {
            en: 'Exterior',
            ar: 'الخارج'
          }
        },
        interiorCamera: {
          title: {
            en: 'First Row Seat',
            ar: 'مقاعد الصف الأول'
          }
        },
        interiorCamera_1: {
          title: {
            en: 'Second Row Seat',
            ar: 'مقاعد الصف الثاني'
          }
        }
      },
      name: {
        en: 'CADILLAC CT5',
        ar: 'كاديلاك CT5'
      },
      specifications: {
        heading: {
          en: 'CADILLAC CT5',
          ar: 'كاديلاك CT5'
        },
        trim: {
          en: 'Blackwing',
          ar: 'Blackwing'
        },
        price: {
          en: '',
          ar: ''
        },
        model: 'CADILLAC CT5',
        seatingCapacity: '5 Seats',
        dimensions: {
          length: '4923 mm',
          width: '',
          height: '',
          wheelbase: '2947 mm',
          groundClearance: ''
        },
        performance: [
          {
            value: '237',
            unit: 'HP',
            label: {
              en: '',
              ar: ''
            }
          },
          {
            value: '350',
            unit: 'NM',
            label: {
              en: 'Torque',
              ar: 'عزم الدوران'
            }
          },
          {
            value: { en: '2.0L', ar: '2.0 لتر' },
            unit: '',
            label: {
              en: 'I4 Engine',
              ar: 'محرك I4'
            }
          }
        ],
        summary: [
          {
            title: {
              en: 'Model',
              ar: 'الطراز'
            },
            subtitle: {
              en: 'CADILLAC CT5',
              ar: 'كاديلاك CT5'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Intuitive Infotainment',
              ar: 'نظام معلومات وترفيه متطور'
            },
            subtitle: {
              en: 'Google built-in infotainment with 33" advanced color LED display',
              ar: 'نظام معلومات وترفيه مع نظام Google المدمج وشاشة LED متطورة ملوّنة قياس 33 بوصة'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Exterior Colors',
              ar: 'الألوان الخارجية'
            },
            subtitle: {
              en: [
                'Argent Silver Metallic',
                'Black Raven',
                'Summit White',
                'Vibrant White Tricoat',
                'Radiant Red Tintcoat',
                'Deep Space Metallic',
                'Coastal Blue Metallic',
                'Typhoon Metallic',
              ],
              ar: [
                'فضي Argent معدني',
                'أسود Raven',
                'أبيض Summit',
                'أبيض Vibrant بثلاث طبقات',
                'أحمر ساطع بطبقتين',
                'Deep Space معدني',
                'أزرق Coastal معدني',
                'Typhoon معدني',
              ]
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Interior',
              ar: 'الألوان الداخلية'
            },
            subtitle: {
              en: [
                'Jet Black',
                'Sahara Beige',
                'Maple Sugar',
                'Sedona Sauvage',
                'Whisper Beige',
                'Natural Tan',
                'Sky Cool Gray',
              ],
              ar: [
                'Jet Black',
                'Sahara Beige',
                'Maple Sugar',
                'Sedona Sauvage',
                'Whisper Beige',
                'Natural Tan',
                'Sky Cool Gray',
              ]
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Wheelbase',
              ar: 'قاعدة العجلات'
            },
            subtitle: {
              en: '2947 mm',
              ar: '2947 مم'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Total Length',
              ar: 'الطول الإجمالي'
            },
            subtitle: {
              en: '4923 mm',
              ar: '4923 مم'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Headroom',
              ar: 'حيّز الرأس'
            },
            subtitle: {
              en: '1st Row - 991mm, 2nd Row -930mm',
              ar: 'الصف الأول: 991 مم، الصف الثاني: 930 مم'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Legroom',
              ar: 'حيّز الأرجل'
            },
            subtitle: {
              en: '1st Row - 1077mm, 2nd Row -963mm',
              ar: 'الصف الأول: 1077 مم، الصف الثاني: 963 مم'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Cargo volume',
              ar: 'حجم الحمولة'
            },
            subtitle: {
              en: '337 Liter',
              ar: '337 لتراً'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Powertrain',
              ar: 'نظام الدفع'
            },
            subtitle: {
              en: '2.0L Twin-Scroll Turbocharged I4 Engine',
              ar: 'محرك I4 بشاحن تيربو مزدوج التمرير بسعة 2.0 لتر'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          },
          {
            title: {
              en: 'Seating Capacity',
              ar: 'عدد المقاعد'
            },
            subtitle: {
              en: '5 Seats',
              ar: '5 مقاعد'
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            }
          }
        ]
      }
    }
  },
  plugins: {
    deferredAssetLoading: true,
  },
  staticTranslations: {
    specDetails: {
      model: {
        en: 'Model',
        ar: 'نموذج',
      },
      exteriorColours: {
        en: 'Exterior',
        ar: 'الخارجة',
      },
      interiorAmbience: {
        en: 'Interior',
        ar: 'الداخلية',
      },
      seatingCapacity: {
        en: 'Seating Capacity',
        ar: 'سعة المقاعد',
      },
      length: {
        en: 'Length',
        ar: 'الطول',
      },
      width: {
        en: 'Width',
        ar: 'العرض',
      },
      height: {
        en: 'Height',
        ar: 'الارتفاع',
      },
      wheelbase: {
        en: 'Wheelbase',
        ar: 'قاعدة العجلات',
      },
      groundClearance: {
        en: 'Ground Clearance',
        ar: 'الخلوص الأرضي',
      },
      share: {
        en: 'Share',
        ar: 'يشارك',
      },
    },
    variantSelection: {
      title: {
        en: 'Model',
        ar: 'نموذج',
      },
      select: {
        en: 'Select',
        ar: 'تحديد',
      },
      cancel: {
        en: 'Cancel',
        ar: 'إلغاء',
      },
      selectBodyStyle: { en: 'Select Body Style', ar: 'اختر نمط الهيكل' },
      availableTrims: { en: 'Select Trim', ar: 'اختر الفئة' },
      driveType: { en: 'Drive Type', ar: 'نوع القيادة' },
      model: { en: 'Model', ar: 'الموديل' },
    },
    loadingScreen: {
      default: {
        en: 'Preparing the canvas for your dream car. Just a few more seconds to go!',
        ar: 'لحظات ونبدأ رحلة تصميم سيارة أحلامك... باقي ثوانٍ قليلة!',
      },
      enterConfigurator: {
        en: 'Build Your Ride',
        ar: 'ابنِ سيارتك',
      },
      loading: { en: 'Loading', ar: 'جارٍ التحميل' },
      variantLoading: { en: 'Trim is loading', ar: 'نموذج جارٍ التحميل' },
      viewLoading: {
        en: 'Applying final touches',
        ar: 'تطبيق اللمسات النهائية',
      },
      disclaimer: {
        en: 'Disclaimer',
        ar: 'تنصل',
      },
      termsConditions: {
        en: 'Terms & Conditions',
        ar: 'الشروط والأحكام',
      },
      viewSpecDetails: {
        en: 'View Spec Details',
        ar: 'ععرض تفاصيل المواصفات',
      },
      disclaimerContent: {
        en: 'Prices are subject to change without prior notice and may vary based on location, availability, or other factors.',
        ar: 'الأسعار عرضة للتغيير دون إشعار مسبق وقد تختلف بناءً على الموقع والتوافر وعوامل أخرى.',
      },
      termsModal: {
        title: {
          en: 'Configurator Use Terms and Conditions',
          ar: 'شروط وأحكام استخدام المُكوِّن',
        },
        lead: {
          en: 'By using this vehicle configurator and submitting your build, you acknowledge and agree to the following:',
          ar: 'من خلال استخدام مُكوِّن تكوين السيارة هذا وإرسال تصميمك، فإنك تقر وتوافق على ما يلي:',
        },
        sections: {
          item1: {
            title: {
              en: 'Non-Binding Submission',
              ar: 'تقديم غير ملزم',
            },
            content: {
              en: 'Submitting your vehicle configuration does not constitute a formal vehicle order or purchase agreement. No payment or deposit is collected at this stage.',
              ar: 'إرسال مواصفات سيارتك لا يُعد طلبًا رسميًا للسيارة أو اتفاقية شراء. لا يتم تحصيل أي مبلغ أو دفعة مقدمة في هذه المرحلة.',
            },
          },
          item2: {
            title: {
              en: 'Preliminary Estimate',
              ar: 'تقدير أولي',
            },
            content: {
              en: 'All pricing displayed is Manufacturer’s Suggested Retail Price (MSRP)and is provided for informational purposes only. Final pricing, taxes, fees, and applicable offers will be confirmed by the authorized dealer.',
              ar: 'جميع الأسعار المعروضة هي سعر التجزئة المقترح من الشركة المصنعة، وهي لأغراض إعلامية فقط. سيتم تأكيد الأسعار النهائية والضرائب والرسوم والعروض المطبقة من قبل الوكيل المعتمد.',
            },
          },
          item3: {
            title: {
              en: 'Dealer Follow-Up',
              ar: 'متابعة التاجر',
            },
            content: {
              en: 'Your submitted configuration will be shared with a participating dealer, who will contact you to discuss your preferences, availability, and next steps.',
              ar: 'سيتم مشاركة التكوين الذي أرسلته مع أحد التجار المشاركين، والذي سيتصل بك لمناقشة تفضيلاتك وتوافرك والخطوات التالية.',
            },
          },
          item4: {
            title: {
              en: 'Availability and Fulfillment',
              ar: 'التوفر والوفاء',
            },
            content: {
              en: 'We will make every reasonable effort to fulfill your preferences; however, final vehicle and accessories selection is subject to dealer inventory and production availability. Configurations may be limited to in-stock or incoming vehicles.',
              ar: 'سنبذل قصارى جهدنا لتلبية تفضيلاتكم، إلا أن الاختيار النهائي للمركبات والملحقات يخضع لمخزون الوكيل وتوافر الإنتاج. قد تقتصر التكوينات على المركبات المتوفرة في المخزون أو الواردة.',
            },
          },
          item5: {
            title: {
              en: 'No Obligation',
              ar: 'لا يوجد التزام',
            },
            content: {
              en: 'You are under no obligation to purchase the configured vehicle, and submitting your configuration does not create a contractual relationship between you and the manufacturer or dealer.',
              ar: 'لا يوجد أي التزام عليك بشراء السيارة المخصصة، كما أن إرسال التكوين الخاص بك لا يؤدي إلى إنشاء علاقة تعاقدية بينك وبين الشركة المصنعة أو التاجر.',
            },
          },
          item6: {
            title: {
              en: 'Use of Personal Information and Consent',
              ar: 'استخدام المعلومات الشخصية والموافقة',
            },
            content: {
              en: 'By submitting your configuration, you consent to the collection, use, and sharing of your personal information with authorized dealers to facilitate your request, in accordance with our [Privacy Statement].',
              ar: 'من خلال إرسال التكوين الخاص بك، فإنك توافق على جمع معلوماتك الشخصية واستخدامها ومشاركتها مع التجار المعتمدين لتسهيل طلبك، وفقًا لـ [بيان الخصوصية] الخاص بنا.',
            },
          },
          item7: {
            title: {
              en: 'System Limitations',
              ar: 'قيود النظام',
            },
            content: {
              en: 'While we aim to provide accurate and current information, the configurator may not reflect all available features or up-to-date pricing. Errors or omissions may occur.',
              ar: 'مع أننا نهدف إلى توفير معلومات دقيقة وحديثة، إلا أن مُكوِّن الإعدادات قد لا يعكس جميع الميزات المتاحة أو الأسعار المُحدَّثة. قد تحدث أخطاء أو سهو.',
            },
          },
        },
      },
    },
    common: {
      exit: {
        en: 'Exit',
        ar: 'خروج',
      },
      close: {
        en: 'Close',
        ar: 'إغلاق',
      },
      cancel: {
        en: 'Cancel',
        ar: 'إلغاء',
      },
      back: {
        en: 'Back',
        ar: 'خلف',
      },
      next: {
        en: 'Next',
        ar: 'التالي',
      },
      done: {
        en: 'Done',
        ar: 'تم',
      },
      exterior: {
        en: 'Exterior',
        ar: 'الخارجة',
      },
      interior: {
        en: 'Interior',
        ar: 'الداخلية',
      },
      enterFullscreen: {
        en: 'Enter Fullscreen',
        ar: 'ملء الشاشة',
      },
      exitFullscreen: {
        en: 'Exit Fullscreen',
        ar: 'إلغاء ملء الشاشة',
      },
      selectTrim: {
        en: 'Select Trim',
        ar: 'اختر الفئة',
      },
      viewConfiguration: {
        en: 'View Configuration',
        ar: 'عرض التكوين',
      },
      togglePanelTooltip: {
        en: 'Select Trim and Configuration',
        ar: 'اختر الفئة والتكوين',
      },
      nextStepTooltip: {
        en: 'Click to proceed to the next step',
        ar: 'انقر للانتقال إلى الخطوة التالية',
      },
      heading: {
        en: 'Standard Features',
        ar: 'المميزات  القياسية',
      },
      description: {
        en: 'Cadillac Arabia',
        ar: 'كاديلاك العربية',
      },
      goBack: { en: 'Go Back', ar: 'العودة' },
      freeRoamView: { en: 'Free Roam View', ar: 'عرض التجوال الحر' },
      featureView: { en: 'Featured View', ar: 'عرض مميز' },
      configurator: { en: 'Configurator', ar: 'المُكوِّن' },
      buildYourRide: { en: 'Build Your Ride', ar: 'ابنِ سيارتك' },
      options: { en: 'Options', ar: 'الخيارات' },
      summary: { en: 'Summary', ar: 'الملخص' },
      saveYourBuild: { en: 'Save Your Build', ar: 'احفظ تكوينك' },
      startingPrice: { en: 'Starting Price', ar: 'السعر الابتدائي' },
      msrp: { en: 'MSRP', ar: 'سعر التجزئة المقترح' },
      proceed: { en: 'Proceed', ar: 'متابعة' },
    },
    tabs: {
      config: { en: 'Config', ar: 'الإعداد' },
      model: { en: 'Model', ar: 'الموديل' },
      exterior: { en: 'Exterior', ar: 'الخارجي' },
      interior: { en: 'Interior', ar: 'الداخلي' },
      options: { en: 'Options', ar: 'الخيارات' },
      summary: { en: 'Summary', ar: 'الملخص' },
    },
    cart: {
      title: {
        en: 'Your Order',
        ar: 'طلبك',
      },
      disclaimer: {
        en: 'Accessory prices and availability will be confirmed at the showroom.',
        ar: 'سيتم تأكيد أسعار الملحقات وتوافرها في صالة العرض.',
      },
      exteriorLabel: {
        en: 'Exterior:',
        ar: ':خارجي',
      },
      interiorLabel: {
        en: 'Interior:',
        ar: ':داخلي',
      },
      addedAccessories: {
        en: 'Added Options',
        ar: 'الخيارات المضافة',
      },
      priceEstimate: {
        en: 'Price Estimate',
        ar: 'السعر التقديري',
      },
      priceBreakdown: {
        en: 'Price Breakdown',
        ar: 'تفاصيل السعر',
      },
      reserveNow: {
        en: 'Proceed',
        ar: 'متابعة',
      },
      removeAccessory: {
        en: 'Remove accessory',
        ar: 'إزالة الإكسسوار',
      },
      removeItem: { en: 'Remove', ar: 'إزالة' },
      packageCategory: { en: 'Package', ar: 'حزمة' },
    },
    saveDialog: {
      optionsTitle: {
        en: 'How would you like to proceed?',
        ar: 'كيف تريد المتابعة؟',
      },
      optionWhatsapp: { en: 'Save to WhatsApp', ar: 'حفظ على واتساب' },
      optionEmail: { en: 'Save to Email', ar: 'حفظ على البريد الإلكتروني' },
      optionTestDrive: {
        en: 'Book a Test Drive',
        ar: 'احجز اختبار قيادة',
      },
      optionCallback: {
        en: 'Request a call Back',
        ar: 'طلب معاودة الاتصال',
      },
      labelFirstName: {
        en: 'First Name*',
        ar: 'الاسم الأول',
      },
      labelLastName: {
        en: 'Last Name*',
        ar: 'اسم العائلة',
      },
      labelEmail: {
        en: 'Email*',
        ar: 'البريد الالكتروني',
      },
      labelMobileNumber: {
        en: 'Mobile Number*',
        ar: 'رقم الجوال',
      },
      labelPrefix: {
        en: 'Prefix',
        ar: 'البادئة',
      },
      labelModel: {
        en: 'Model',
        ar: 'نموذج',
      },
      labelDealership: {
        en: 'Preferred Dealership*',
        ar: 'الوكيل المفضّل',
      },
      labelComments: {
        en: 'Comments',
        ar: 'تعليقات',
      },
      labelTestDriveDate: {
        en: 'Preferred date*',
        ar: 'التاريخ المفضل*',
      },
      labelTestDriveTime: {
        en: 'Preferred time*',
        ar: 'الوقت المفضل*',
      },
      placeholderTestDriveDate: {
        en: 'Preferred date*',
        ar: 'التاريخ المفضل*',
      },
      placeholderTestDriveTime: {
        en: 'Preferred time*',
        ar: 'الوقت المفضل*',
      },
      placeholderFirstName: {
        en: 'First Name*',
        ar: 'الاسم الأول',
      },
      placeholderLastName: {
        en: 'Last Name*',
        ar: 'اسم العائلة',
      },
      placeholderEmail: {
        en: 'Email*',
        ar: 'البريد الالكتروني',
      },
      placeholderMobileNumber: {
        en: 'Mobile Number*',
        ar: 'رقم الجوال',
      },
      placeholderComments: {
        en: 'Comments',
        ar: 'تعليقات',
      },
      placeholderSelectDealership: {
        en: 'Preferred Dealership*',
        ar: 'الوكيل المفضّل',
      },
      privacyTitle: {
        en: 'Privacy statement & legal disclaimer',
        ar: 'بيان الخصوصية وإخلاء المسؤولية القانونية',
      },
      privacyText: {
        en: 'I acknowledge and understand that my information will be shared with General Motors, its affiliates, dealer network or other parties are required by law for compliance, safety campaigns, government inquiries, or similar legal process. My information may also be shared for product research and development purposes, and to manage customer relationships to provide support. GM’s Privacy Statement addresses how GM handles the personal information shared with us.',
        ar: 'أقر وأتفهم بأنة سيتم مشاركة معلوماتي مع شركة جنرال موتورز، والشركات التابعة لها، وشبكة الوكلاء أو الأطراف الأخرى بموجب القانون للامتثال وحملات السلامة واستفسارات الحكومية وأي إجراء قانوني مماثل. وقد تتم مشاركة معلوماتي أيضًا لأغراض البحث وتطوير المنتجات ، وإدارة علاقة العملاء لتوفير الدعم اللازم. يوضح بيان خصوصية جنرال موتورز على موقعنا كيفية تعامل جنرال موتورز مع المعلومات الشخصية التي تمت مشاركتها معنا.',
      },
      privacyReadMore: {
        en: 'Read more',
        ar: 'اقرأ المزيد',
      },
      privacyReadMoreUrl: {
        en: 'https://www.cadillacarabia.com/ae-en/privacy-statement',
        ar: 'https://www.cadillacarabia.com/ae-ar/privacy-statement',
      },
      privacyMarketingConsent: {
        en: 'I wish to receive any marketing information or have my information shared with third parties for purposes of providing me with marketing information.',
        ar: 'أرغب في تلقي معلومات تسويقية أو مشاركة معلوماتي مع جهات خارجية لغاية تزويدي بمعلومات تسويقية',
      },
      buttonSend: {
        en: 'Send Configuration',
        ar: 'إرسال التكوين',
      },
      buttonSending: {
        en: 'Submitting...',
        ar: 'تقديم...',
      },
      buttonSent: {
        en: 'Sent!',
        ar: 'مرسل!',
      },
      buttonRetry: {
        en: 'Retry',
        ar: 'إعادة المحاولة',
      },
      buttonClose: {
        en: 'Okay, Got it',
        ar: 'حسنًا، فهمت',
      },
      successTitle: {
        en: 'Saved',
        ar: 'محفوظ',
      },
      successLabelModel: {
        en: 'Model Name',
        ar: 'اسم النموذج',
      },
      successLabelVariant: {
        en: 'Variant Name',
        ar: 'اسم البديل',
      },
      successLabelName: {
        en: 'Name',
        ar: 'اسم',
      },
      successLabelEmail: {
        en: 'Email*',
        ar: 'البريد الالكتروني',
      },
      successLabelMobile: {
        en: 'Mobile Number*',
        ar: 'رقم الجوال',
      },
      qrTitle: {
        en: 'Your Unique Configuration QR',
        ar: 'رمز الاستجابة السريعة لتكوينك',
      },
      qrDescription: {
        en: 'Show this QR code to your nearest dealer to access your saved configuration.',
        ar: 'أظهر رمز الاستجابة السريعة هذا لتاجر التجزئة الأقرب للوصول إلى التكوين المحفوظ.',
      },
      qrNoteLabel: {
        en: 'Note:',
        ar: 'ملاحظة:',
      },
      qrNote: {
        en: 'Only authorized dealers can view this configuration.',
        ar: 'يمكن للوكلاء المعتمدين فقط عرض هذا التكوين.',
      },
      qrDownload: {
        en: 'Download QR',
        ar: 'تحميل QR',
      },
      qrSave: {
        en: 'Save QR',
        ar: 'حفظ QR',
      },
      errorTitle: {
        en: 'Submission Failed',
        ar: 'فشل التقديم',
      },
      errorMessage: {
        en: 'We encountered an error, please try again.',
        ar: 'واجهنا خطأ، يرجى المحاولة مرة أخرى.',
      },
    },
    featureGroups: {
      exteriorDesign: {
        en: 'Exterior Design & Styling',
        ar: 'التصميم الخارجي والتصميم',
      },
      interiorComfort: {
        en: 'Interior Comfort & Features',
        ar: 'الراحة والميزات الداخلية',
      },
      technologyConvenience: {
        en: 'Technology & Convenience',
        ar: 'التكنولوجيا والراحة',
      },
      safetyAssistance: {
        en: 'Safety & Driver Assistance',
        ar: 'السلامة ومساعدة السائق',
      },
    },
    sidePanel: {
      menu: { en: 'Main Menu', ar: 'القائمة الرئيسية' },
      search: { en: 'Search', ar: 'بحث' },
      settings: { en: 'Settings', ar: 'الإعدادات' },
      profile: { en: 'Profile', ar: 'الملف الشخصي' },
      notifications: { en: 'Notifications', ar: 'الإشعارات' },
      help: { en: 'Help & Support', ar: 'المساعدة والدعم' },
      filter: { en: 'Filter Options', ar: 'خيارات التصفية' },
      favorites: { en: 'Favorites', ar: 'المفضلة' },
      history: { en: 'History', ar: 'التاريخ' },
      tools: { en: 'Tools', ar: 'الأدوات' },
      variants: { en: 'Variants', ar: 'الأنواع' },
      exteriorColor: { en: 'Exterior Color', ar: 'لون الهيكل' },
      interiorColor: { en: 'Interior Color', ar: 'ألوان المقصورة' },
      features: { en: 'Features', ar: 'الميزات' },
      step: { en: 'Step', ar: 'خطوة' },
      openPanel: { en: 'Open Panel', ar: 'فتح اللوحة' },
      closePanel: { en: 'Close Panel', ar: 'إغلاق اللوحة' },
    },
    landscape: {
      message: {
        en: 'Please rotate your device to portrait mode',
        ar: 'يرجى تدوير جهازك إلى الوضع الرأسي',
      },
      subtitle: {
        en: 'For the best experience, please turn your device upright.',
        ar: 'للحصول على أفضل تجربة، يرجى إمساك جهازك بشكل رأسي.',
      },
    },
    cameraViewToggle: {
      ext: { en: 'Ext', ar: 'خارجي' },
      int: { en: 'Int', ar: 'داخلي' },
      dualTone: { en: 'Dual-tone', ar: 'لون مزدوج' },
    },
    bottomDrawer: {
      variants: { en: 'Variants', ar: 'الأنواع' },
      interactions: { en: 'Interactions', ar: 'التفاعلات' },
      accessories: { en: 'Options & Accessories', ar: 'الإكسسوارات' },
      features: { en: 'Features', ar: 'الميزات' },
      highlights: { en: 'Highlights', ar: 'الميزات البارزة' },
      moreOptions: { en: 'More Options', ar: 'المزيد من الخيارات' },
      colorSelector: { en: 'Color Selector', ar: 'محدد اللون' },
      exteriorColor: { en: 'Exterior Color', ar: 'لون الهيكل' },
      interiorColor: { en: 'Interior Color', ar: 'لون المقصورة' },
      wheels: { en: 'Wheels', ar: 'العجلات' },
      roofs: { en: 'Roofs', ar: 'الأسقف' },
      performance: { en: 'Performance', ar: 'الأداء' },
      packages: { en: 'Packages', ar: 'الحزم' },
      chargingOptions: { en: 'Charging Options', ar: 'خيارات الشحن' },
      safetyServices: { en: 'Safety & Services', ar: 'السلامة والخدمات' },
      expand: { en: 'Expand', ar: 'توسيع' },
      minimize: { en: 'Minimize', ar: 'تصغير' },
      freeRoamView: { en: 'Free Roam View', ar: 'عرض التجوال الحر' },
      featureView: { en: 'Featured View', ar: 'العرض المميز' },
    },
    qr: {
      scan: { en: 'Scan QR', ar: 'امسح رمز الاستجابة السريعة' },
      scanWithPhone: {
        en: 'Scan with your phone to view in your Space',
        ar: 'امسح باستخدام هاتفك لعرضه في مساحتك',
      },
    },
    share: {
      title: { en: 'Share Configuration', ar: 'مشاركة التكوين' },
      description: {
        en: 'Share your vehicle configuration with others',
        ar: 'شارك تكوين سيارتك مع الآخرين',
      },
      twitterTitle: {
        en: 'Check out my Cadillac CT5 configuration!',
        ar: 'شاهد تكوين سيارتي كاديلاك CT5!',
      },
      whatsappTitle: {
        en: 'Check out my Cadillac CT5 configuration!',
        ar: 'شاهد تكوين سيارتي كاديلاك CT5!',
      },
      linkedinTitle: {
        en: 'My Cadillac CT5 Configuration',
        ar: 'تكويني لسيارة كاديلاك CT5',
      },
      linkedinSummary: {
        en: 'Check out my custom Cadillac CT5 configuration!',
        ar: 'شاهد تكويني المخصص لسيارة كاديلاك CT5!',
      },
      emailSubject: {
        en: 'Check out my Cadillac CT5 Configuration',
        ar: 'شاهد تكوين سيارتي كاديلاك CT5',
      },
      emailBody: {
        en: 'I configured my dream Cadillac CT5. Take a look:',
        ar: 'قمت بتكوين سيارة كاديلاك CT5 المثالية. ألق نظرة:',
      },
      linkLabel: { en: 'Or copy link:', ar: 'أو انسخ الرابط:' },
      copied: {
        en: 'Copied',
        ar: 'تم نسخ الرابط إلى الحافظة!',
      },
      copy: { en: 'Copy', ar: 'نسخ' },
      saveAndShare: { en: 'Save & Share', ar: 'حفظ ومشاركة' },
      copyLink: { en: 'Copy link', ar: 'نسخ الرابط' },
      facebook: { en: 'Facebook', ar: 'Facebook' },
      twitter: { en: 'Twitter', ar: 'Twitter' },
      gmail: { en: 'Gmail', ar: 'Gmail' },
      whatsapp: { en: 'Whatsapp', ar: 'Whatsapp' },
    },
    topBar: {
      matchingVehiclesFound: {
        en: 'Matching Vehicles Found',
        ar: 'تم العثور على المركبات المطابقة',
      },
    },
    bottomBar: {
      priceLabel: { en: 'ex showroom price', ar: 'سعر صالة العرض' },
      leads: { en: 'Save', ar: 'حفظ' },
      findLocalMatches: {
        en: 'Find Local Matches',
        ar: 'اعثر على التطابقات المحلية',
      },
      save: { en: 'Save', ar: 'حفظ' },
      item: { en: 'Item', ar: 'العنصر' },
      items: { en: 'Items', ar: 'عناصر' },
      totalToPay: { en: 'Total to pay', ar: 'الإجمالي للدفع' },
      bookTestDrive: { en: 'Save', ar: 'حفظ' },
      requestQuote: { en: 'Request a Quote', ar: 'طلب عرض سعر' },
      downloadBrochure: { en: 'Download Brochure', ar: 'تحميل الكتيب' },
    },
    priceSummary: {
      title: { en: 'Price Summary', ar: 'ملخص السعر' },
      enterLocation: { en: 'Enter Location', ar: 'أدخل الموقع' },
      selectCountry: { en: 'Location', ar: 'الموقع' },
      selectCity: { en: 'Location', ar: 'الموقع' },
      note: {
        en: 'Note : Prices might vary by state and all prices listed are on road price, T&C apply.',
        ar: 'ملاحظة: قد تختلف الأسعار حسب الولاية وجميع الأسعار المذكورة هي الأسعار على الطريق، تطبق الشروط والأحكام.',
      },
      breakdown: { en: 'Price Breakdown', ar: 'تفصيل السعر' },
      color: { en: 'Color', ar: 'اللون' },
      variant: { en: 'Variant', ar: 'الفئة' },
      included: { en: 'Included', ar: 'مشمول' },
      total: { en: 'Total', ar: 'الإجمالي' },
    },
    featureDialog: {
      playPause: { en: 'Play-Pause', ar: 'تشغيل-إيقاف' },
    },
    selectDealership: {
      title: { en: 'Select a Dealer', ar: 'اختر وكيلاً' },
      subtitle: {
        en: 'Please select a dealer to find local matches similar to your configuration',
        ar: 'يرجى اختيار وكيل للعثور على سيارات مطابقة لتكوينك في منطقتك',
      },
      city: { en: 'UAE', ar: 'الإمارات' },
      dealersIn: { en: 'Dealers in', ar: 'وكلاء في' },
      dealersInCity: { en: 'Dealers in {{city}}', ar: 'وكلاء في {{city}}' },
      availableInLocations: {
        en: 'Available in {{count}} locations of {{city}}',
        ar: 'متوفرة في {{count}} مواقع في {{city}}',
      },
      proceed: {
        en: 'Select Dealer and Proceed to Configurator',
        ar: 'اختر الوكيل وتابع إلى المتكون',
      },
    },
    countryNames: {
      UAE: { en: 'UAE', ar: 'الإمارات' },
      KSA: { en: 'KSA', ar: 'السعودية' },
      KW: { en: 'Kuwait', ar: 'الكويت' },
      default: { en: 'UAE', ar: 'الإمارات' },
    },
    localMatches: {
      exterior: { en: 'Exterior', ar: 'خارجي' },
      interior: { en: 'Interior', ar: 'داخلي' },
      dualTone: { en: 'Dual-tone', ar: 'لون مزدوج' },
      yourConfiguration: { en: 'Current Configuration', ar: 'التكوين الحالي' },
      viewConfiguration: {
        en: 'View your configuration details',
        ar: 'عرض تفاصيل تكوينك',
      },
      yourBuildDetails: { en: 'Your Build Details', ar: 'تفاصيل بنائك' },
      options: { en: 'Options', ar: 'الخيارات' },
      save: { en: 'Save', ar: 'حفظ' },
      dealersIn: { en: 'Dealers in', ar: 'وكلاء في' },
      changeDealer: { en: 'Change Dealer', ar: 'تغيير الوكيل' },
      carsAvailable: {
        en: 'Cars Available at the Selected Dealership',
        ar: 'السيارات المتوفرة لدى الوكيل المختار',
      },
      matchesFound: { en: 'Matches found', ar: 'تطابق تم العثور عليه' },
      startingFrom: { en: 'Starting from', ar: 'يبدأ من' },
      getQuote: { en: 'Proceed', ar: 'احصل على عرض سعر' },
      viewDifferences: { en: 'View Differences', ar: 'عرض الاختلافات' },
      match: { en: 'Match', ar: 'تطابق' },
      closestMatchFound: {
        en: 'Closest Match Found',
        ar: 'أقرب تطابق تم العثور عليه',
      },
      buildDetails: { en: 'Build Details', ar: 'تفاصيل التكوين' },
      trim: { en: 'Trim', ar: 'الفئة' },
      matchScoreTooltip: {
        en: 'This score indicates how closely this vehicle matches your configuration.',
        ar: 'يشير هذا النتيجة إلى مدى تطابق هذه السيارة مع تكوينك.',
      },
      exactMatch: { en: 'Exact Match', ar: 'تطابق تام' },
      similarMatch: { en: 'Close Match', ar: 'تطابق قريب' },
      availableNow: { en: 'Available Now', ar: 'متوفر الآن' },
      whatYouConfigured: { en: 'What you configured', ar: 'ما قمت بتكوينه' },
      matchingInStock: { en: 'Matching vehicle available in stock', ar: 'مركبة مطابقة متوفرة في المخزون' },
      noMatches: {
        en: 'No matching vehicles found in your area.',
        ar: 'لم يتم العثور على سيارات مطابقة في منطقتك.',
      },
      closeMatchDetails: { en: 'Close Match Details', ar: 'تفاصيل التطابق القريب' },
      matchesYourSelection: { en: 'Matches your selection', ar: 'يطابق اختيارك' },
      sameAsWhatYouSelected: { en: 'Same as what you selected', ar: 'نفس ما اخترته' },
      replacesYourSelection: { en: 'Replaces your selection', ar: 'يستبدل اختيارك' },
      selectionNotIncluded: { en: 'Selection not included', ar: 'الاختيار غير مشمول' },
      includedInThisVehicle: { en: 'Included in this vehicle', ar: 'مشمول في هذه المركبة' },
      additionalFeatureAlreadyIncluded: { en: 'Additional feature already included', ar: 'ميزة إضافية مشمولة بالفعل' },
      stockDisclaimer: { en: 'Available stock may include extra features not selected in your original configuration.', ar: 'قد تشمل المركبات المتاحة ميزات إضافية لم تختارها في تكوينك الأصلي.' },
      additionalInstalledOptionsLegend: { en: 'Included in this vehicle', ar: 'مشمول في هذه المركبة' },
      vehicleDetails: { en: 'Vehicle Details', ar: 'تفاصيل المركبة' },
      installedOptionsTitle: { en: 'Comes with vehicle', ar: 'يأتي مع المركبة' },
      additionalInstalledOptionsSubtitle: { en: 'Additional Installed Options:', ar: 'الخيارات المركبة الإضافية:' },
      specTrim: { en: 'Trim', ar: 'الفئة' },
      specExteriorColor: { en: 'Exterior Color', ar: 'اللون الخارجي' },
      specInteriorColor: { en: 'Interior Color', ar: 'اللون الداخلي' },
      specWheels: { en: 'Wheels', ar: 'العجلات' },
      specPackage: { en: 'Package', ar: 'الحزمة' },
      title: {
        en: 'Configurations Found',
        ar: 'تكوينات تم العثور عليها',
      },
      message: {
        en: 'We Found a few local matches similar to your current configuration. Click to view Matches',
        ar: 'وجدنا بعض التطابقات المحلية المشابهة لتكوينك الحالي. انقر لعرض التطابقات',
      },
    },
    trim: {
      selection: { en: 'Trim Selection', ar: 'اختيار الفئة' },
    },
    paymentPage: {
      exteriorColor: { en: 'Exterior Color', ar: 'لون الهيكل' },
      interiorColor: { en: 'Interior Color', ar: 'لون المقصورة' },
      accessory: { en: 'Accessory', ar: 'ملحق' },
      closePayment: { en: 'Close', ar: 'إغلاق' },
    },
    packageModal: {
      includes: { en: 'Includes:', ar: 'يشمل:' },
      of: { en: 'of', ar: 'من' },
      totalPriceChange: {
        en: 'Total Price Change:',
        ar: 'إجمالي تغيير السعر:',
      },
      item: { en: 'Item', ar: 'غرض' },
      items: { en: 'Items', ar: 'أغراض' },
      addPackage: { en: 'Add Package', ar: 'إضافة الحزمة' },
      noThanks: { en: 'No Thanks', ar: 'لا شكراً' },
      alreadyApplied: { en: 'Already Applied', ar: 'مُطبّق بالفعل' },
    },
    changesRequired: { en: 'Changes Required', ar: 'التغييرات المطلوبة' },
    changesRequiredDescription: {
      en: 'The package you selected conflicts with your current selections. Please review the changes below.',
      ar: 'الحزمة التي اخترتها تتعارض مع اختياراتك الحالية. يرجى مراجعة التغييرات أدناه.',
    },
    itemsThatWillBeRemoved: {
      en: 'Items that will be removed',
      ar: 'العناصر التي سيتم إزالتها',
    },
    itemsThatWillBeAdded: {
      en: 'Items that will be added',
      ar: 'العناصر التي سيتم إضافتها',
    },
    applyChanges: { en: 'Apply Changes', ar: 'تطبيق التغييرات' },
    previewFeature: { en: 'Preview Feature', ar: 'معاينة الميزة' },
    exploreFeatures: { en: 'Explore Features', ar: 'استكشف الميزات' },
    buildAndPrice: { en: 'Build & Price', ar: 'البناء والسعر' },
    features: {
      preview: { en: 'Preview Feature', ar: 'معاينة المميزات' },
      playAll: { en: 'PLAY ALL', ar: 'تشغيل الكل' },
      title: { en: 'Features', ar: 'المميزات' },
    },
    header: {
      localMatches: { en: 'Local\nMatches', ar: 'التطابقات\nالمحلية' },
      matchingVehicles: { en: 'Matching vehicles', ar: 'مركبات مطابقة' },
      configurationsFound: { en: 'Configurations Found', ar: 'تكوينات تم العثور عليها' },
    },
    configPanel: {
      playAll: { en: 'Play All', ar: 'تشغيل الكل' },
      pause: { en: 'Pause', ar: 'إيقاف مؤقت' },
      exteriorColors: { en: 'Exterior Colors', ar: 'ألوان الهيكل الخارجي' },
      interiorColors: { en: 'Interior Colors', ar: 'ألوان الداخلية' },
      roofOptions: { en: 'Roof Options', ar: 'خيارات السقف' },
      interiorOptions: { en: 'Interior Options', ar: 'خيارات الداخلية' },
      exteriorAccessories: { en: 'Exterior Options', ar: 'خيارات الخارجية' },
      noAdditionalOptions: { en: 'No additional options available for the selected trim.', ar: 'لا توجد خيارات إضافية متاحة للفئة المختارة.' },
      noFilters: { en: 'No filters available.', ar: 'لا توجد فلاتر متاحة.' },
      noVariantsMatch: { en: 'No trims match the selected filters.', ar: 'لا توجد فئات تطابق الفلاتر المختارة.' },
      configurationBreakdown: { en: 'Configuration Breakdown', ar: 'تفاصيل التكوين' },
      yourConfiguration: { en: 'Your Configuration', ar: 'تكوينك' },
      trim: { en: 'Trim', ar: 'الفئة' },
      total: { en: 'Total', ar: 'الإجمالي' },
    },
    conflictDialog: {
      description: { en: 'In order to apply this, the following item(s) will need to be removed due to compatibility constraints. Please review the item(s) below and proceed with your change.', ar: 'لتطبيق هذا، يجب إزالة العناصر التالية بسبب قيود التوافق. يرجى مراجعة العناصر أدناه والمتابعة بتغييرك.' },
    },
    viewport: {
      changeBackground: { en: 'Change Background', ar: 'تغيير الخلفية' },
      selectLanguage: { en: 'Switch Language (عربي)', ar: 'تبديل اللغة (EN)' },
      menu: { en: 'Menu', ar: 'القائمة' },
      exploreFeatures: { en: 'Explore Features', ar: 'استكشف الميزات' },
    },
  },
  dealers: {
    UAE: [
      {
        id: 0,
        country: 'UAE',
        value: '',
        dealerId: '122255',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Quoz 3 Industrial Area Sheikh Zayed Road, Dubai',
          ar: 'الكندي للسيارات - القوز 3، المنطقة الصناعية، طريق الشيخ زايد، دبي',
        },
      },
      {
        id: 1,
        country: 'UAE',
        value: '',
        dealerId: '256427',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Double Cola Road, Sharjah',
          ar: 'الكندي للسيارات - طريق دبل كولا، الشارقة',
        },
      },
      {
        id: 2,
        country: 'UAE',
        value: '',
        dealerId: '256428',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Madhab Mohammad Bin Mattar Street, Fujairah',
          ar: 'الغاندي للسيارات - شارع مذهب محمد بن مطر، الفجيرة',
        },
      },
      {
        id: 3,
        country: 'UAE',
        value: '',
        dealerId: '256429',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Nadiyah Sheikh Mohammed Bin Salem Road, Ras Al Khaimah',
          ar: 'الكندي للسيارات - الندية طريق الشيخ محمد بن سالم، رأس الخيمة',
        },
      },
      {
        id: 4,
        country: 'UAE',
        value: '',
        dealerId: '301597',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Itihad Road - showroom , Al Khabaisi, Deira, Dubai',
          ar: 'الكندي للسيارات - طريق الاتحاد - صالة عرض , الخبيصي, ديرة, دبي',
        },
      },
      {
        id: 8,
        country: 'UAE',
        value: '',
        dealerId: '334821',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi - Mirdiff City Center',
          ar: 'الغاندي - مردف سيتي سنتر',
        },
      },
      {
        id: 5,
        country: 'UAE',
        value: '',
        dealerId: '321719',
        dealerName: '',
        label: {
          en: 'Al Ghandi Auto - City Walk Boulevard - Happiness Street, Dubai',
          ar: 'الكندي للسيارات - بوليفارد سيتي ووك - شارع السعادة، دبي',
        },
      },
      {
        id: 6,
        country: 'UAE',
        value: '',
        dealerId: '311027',
        dealerName: '',
        label: {
          en: 'Al Ghandi Auto - Umm Al Nar, Al Ain Road, Abu Dhabi',
          ar: 'الكندي للسيارات - أم النار، طريق العين، أبوظبي',
        },
      },
      {
        id: 7,
        country: 'UAE',
        value: '',
        dealerId: '315694',
        dealerName: '',
        label: {
          en: 'Al Ghandi Auto - Al Waha Building, Al Ain',
          ar: 'الكندي للسيارات - مبنى الواحة، العين',
        },
      },
    ],
    KSA: [
      {
        id: 0,
        country: 'KSA',
        value: '',
        dealerId: '307261',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Al Aziziyah Madina Road, Jeddah',
          ar: 'الجميح للسيارات - العزيزية طريق المدينة، جدة',
        },
      },
      {
        id: 1,
        country: 'KSA',
        value: '',
        dealerId: '164034',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Hail City King Abdullah Road. Hail',
          ar: 'الجميح للسيارات - مدينة حائل طريق الملك عبدالله. يشيد',
        },
      },
      {
        id: 2,
        country: 'KSA',
        value: '',
        dealerId: '164035',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Alshlhoub King Abdullah Road, Al Jouf',
          ar: 'الجميح للسيارات - الشلهوب طريق الملك عبدالله، الجوف',
        },
      },
      {
        id: 3,
        country: 'KSA',
        value: '',
        dealerId: '307271',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Qassim King Abdulaziz Road, Buraidah',
          ar: 'الجميح للسيارات - القصيم طريق الملك عبد العزيز، بريدة',
        },
      },
      {
        id: 4,
        country: 'KSA',
        value: '',
        dealerId: '260921',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Al Jededah Road, Arar',
          ar: 'الجميح للسيارات - طريق الجديدة، عرعر',
        },
      },
      {
        id: 5,
        country: 'KSA',
        value: '',
        dealerId: '318928',
        dealerName: '',
        label: {
          en: 'Aljomaih Auto - King Fahad Road, Dammam',
          ar: 'الجميح للسيارات - طريق الملك فهد، الدمام',
        },
      },
      {
        id: 6,
        country: 'KSA',
        value: '',
        dealerId: '213142',
        dealerName: '',
        label: {
          en: 'Aljomaih Auto - Rawdah Khurais Road, Riyadh',
          ar: 'الجميح للسيارات - طريق الروضة خريص، الرياض',
        },
      },
      {
        id: 7,
        country: 'KSA',
        value: '',
        dealerId: '307267',
        dealerName: '',
        label: {
          en: 'Aljomaih Auto - Malibari Al Madina Road, Jeddah',
          ar: 'الجميح للسيارات - طريق ماليباري المدينة، جدة',
        },
      },
    ],
    KW: [
      {
        id: 0,
        country: 'KW',
        value: '',
        dealerId: '122620',
        dealerName: 'Alamana Auto',
        label: {
          en: 'Alamana Auto - Al Rai 4th Ring Road, Al Rai',
          ar: 'الامانة للسيارات - الري الطريق الدائري الرابع، الري',
        },
      },
      {
        id: 1,
        country: 'KW',
        value: '',
        dealerId: '174979',
        dealerName: 'Alamana Auto',
        label: {
          en: 'Alamana Auto - Fahaheel Industrial Area Dabbous Street, Fahaheel',
          ar: 'الامانة للسيارات - الفحيحيل الصناعية شارع الدبوس، الفحيحيل',
        },
      },
    ],
    BHD: [
      {
        id: 0,
        country: 'BHD',
        value: 'BHD',
        dealerId: '122215',
        dealerName: 'National Motor Company W.L.L',
        label: {
          en: 'National Motor Company W.L.L, Al Qarya 475 Shk. Jaber Al Subah Hwy',
          ar: 'الشركة الوطنية للسيارات ذ.م.م، القرية 475 شارع الشيخ. طريق جابر الصباح',
        },
      },
    ],
    LBP: [
      {
        id: 0,
        country: 'LBP',
        value: 'LBP',
        dealerId: '122226',
        dealerName: 'IMPEX',
        label: {
          en: 'IMPEX -  Badaro, Near the National Museum , Beirut',
          ar: 'إمبكس - بدارو، بالقرب من المتحف الوطني، بيروت',
        },
      },
    ],
    OMR: [
      {
        id: 0,
        country: 'OMR',
        value: 'OMR',
        dealerId: '259952',
        dealerName: 'Oman Trading Establisment',
        label: {
          en: 'Oman Trading Establisment LLC, Ghalla Al Maardh Street',
          ar: 'مؤسسة عمان التجارية ش.م.م، شارع غلا المعرض',
        },
      },
    ],
    QAR: [
      {
        id: 0,
        country: 'QAR',
        value: 'QAR',
        dealerId: '122234',
        dealerName: 'Mannai Trading Company',
        label: {
          en: 'Mannai Trading Company W.L.L., Salwa E Industrial Street',
          ar: 'شركة مناعي التجارية ذ.م.م، شارع سلوى إي الصناعي',
        },
      },
    ],
    JOD: [
      {
        id: 0,
        country: 'JOD',
        value: 'JOD',
        dealerId: '189129',
        dealerName: 'Leading Vehicles',
        label: {
          en: 'The Leading Vehicles Co. Ltd, Al Rawabi',
          ar: 'شركة المركبات الرائدة المحدودة، الروابي',
        },
      },
    ],
    default: [
      {
        id: 0,
        country: 'UAE',
        value: '',
        dealerId: '122255',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Quoz 3 Industrial Area Sheikh Zayed Road, Dubai',
          ar: 'الكندي للسيارات - القوز 3، المنطقة الصناعية، طريق الشيخ زايد، دبي',
        },
      },
      {
        id: 1,
        country: 'UAE',
        value: '',
        dealerId: '256427',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Double Cola Road, Sharjah',
          ar: 'الكندي للسيارات - طريق دبل كولا، الشارقة',
        },
      },
      {
        id: 2,
        country: 'UAE',
        value: '',
        dealerId: '256428',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Madhab Mohammad Bin Mattar Street, Fujairah',
          ar: 'الغاندي للسيارات - شارع مذهب محمد بن مطر، الفجيرة',
        },
      },
      {
        id: 3,
        country: 'UAE',
        value: '',
        dealerId: '256429',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Nadiyah Sheikh Mohammed Bin Salem Road, Ras Al Khaimah',
          ar: 'الكندي للسيارات - الندية طريق الشيخ محمد بن سالم، رأس الخيمة',
        },
      },
      {
        id: 4,
        country: 'UAE',
        value: '',
        dealerId: '301597',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Itihad Road - showroom , Al Khabaisi, Deira, Dubai',
          ar: 'الكندي للسيارات - طريق الاتحاد - صالة عرض , الخبيصي, ديرة, دبي',
        },
      },
      {
        id: 8,
        country: 'UAE',
        value: '',
        dealerId: '334821',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi - Mirdiff City Center',
          ar: 'الغاندي - مردف سيتي سنتر',
        },
      },
      {
        id: 5,
        country: 'UAE',
        value: '',
        dealerId: '321719',
        dealerName: '',
        label: {
          en: 'Al Ghandi Auto - City Walk Boulevard - Happiness Street, Dubai',
          ar: 'الكندي للسيارات - بوليفارد سيتي ووك - شارع السعادة، دبي',
        },
      },
      {
        id: 6,
        country: 'UAE',
        value: '',
        dealerId: '311027',
        dealerName: '',
        label: {
          en: 'Al Ghandi Auto - Umm Al Nar, Al Ain Road, Abu Dhabi',
          ar: 'الكندي للسيارات - أم النار، طريق العين، أبوظبي',
        },
      },
      {
        id: 7,
        country: 'UAE',
        value: '',
        dealerId: '315694',
        dealerName: '',
        label: {
          en: 'Al Ghandi Auto - Al Waha Building, Al Ain',
          ar: 'الكندي للسيارات - مبنى الواحة، العين',
        },
      },
    ],
  },
  featureFlags: {
    showPriceInPresentation: false,
    showLogo: true,
    showSpecDetailsButton: true,
    useChevroletFont: false,
    showLocalMatches: false, // CT5: no dealer selector / Matching Vehicles on any link
    showDisclaimerInPresentation: false,
    showPrices: false,
    showDisplayCarPrice: false,
    showCart: false
  },
  config: {
    // Display currency + USD conversion factor per region, keyed by the
    // `country` URL parameter (local = usd * fx). Prices were re-derived
    // from the AED figure: usd = AED / 3.68, then usd * fx per country.
    regions: {
      KSA: { label: 'KSA', currency: 'SAR', fx: 3.75 },
      UAE: { label: 'UAE', currency: 'AED', fx: 3.68 },
      OMR: { label: 'Oman', currency: 'OMR', fx: 0.39 },
      BHD: { label: 'Bahrain', currency: 'BHD', fx: 0.38 },
      QAR: { label: 'Qatar', currency: 'QAR', fx: 3.64 },
      JOD: { label: 'Jordan', currency: 'JOD', fx: 0.71 },
      KW: { label: 'Kuwait', currency: 'KWD', fx: 0.31 },
      LBP: { label: 'Lebanon', currency: 'USD', fx: 1 }, // GM quotes Lebanon in USD
      IQD: { label: 'Iraq', currency: 'USD', fx: 1 }, // priced in USD, like Lebanon
      default: { label: 'UAE', currency: 'AED', fx: 3.68 },
    },
    // Lead-side model name — 1.0's `config.model`, which is a lead label
    // distinct from 2.0's `config.model` (the models[] key).
    leadModel: 'CT5',
    // Dial code (prefixed onto mobile_number) and Salesforce lead country
    // code (metadome_country_code), keyed by the `country` URL parameter.
    countryCodes: {
      UAE: {
        code: '+971',
        leadCode: 'AE',
      },
      KSA: {
        code: '+966',
        leadCode: 'SA',
      },
      KW: {
        code: '+965',
        leadCode: 'KW',
      },
      BHD: {
        code: '+973',
        leadCode: 'BH',
      },
      IQD: {
        code: '+964',
        leadCode: 'IQ',
      },
      LBP: {
        code: '+961',
        leadCode: 'LB',
      },
      OMR: {
        code: '+968',
        leadCode: 'OM',
      },
      QAR: {
        code: '+974',
        leadCode: 'QA',
      },
      JOD: {
        code: '+962',
        leadCode: 'JO',
      },
      default: {
        code: '+971',
        leadCode: 'AE',
      },
    },
    model: 'CT5',
    modelName: 'CT5',
    pageTitle: 'CT5 Configurator',
    // CT5 assets are published only on the alpha release channel. Pin the
    // channel per-project (same precedent as 2387/Corvette) so it resolves
    // to alpha in every environment, including deployed builds, instead of
    // falling back to gammaVersion where assets don't exist yet.
    releaseChannel: 'alphaVersion',
    client: 'GM',
    brand: 'cadillac',
    modelId: 'CACT52026',
    configurationId: 'l25zrwex1u93',
    externalAnalytics: {
      brand: 'cadillac',
      provider: 'adobe',
      modelName: 'CT5'
    },
    presentation: {
      video: 'videos/2384/presentation_video_desktop.webm',
      // Phone-specific cut of the same loading-screen video (portrait, 1080x1920)
      // — LoadingProgress.tsx swaps to this one under the isMobile breakpoint.
      videoMobile: 'videos/2384/presentation_video_mobile.webm',
      loadingImage: 'images/2384/sliderImage.webp',
      transitionImage: 'images/2384/transition_logo.png',
      // Header-only crest (Header.tsx) — kept separate from transitionImage,
      // which the presentation/loading screen still uses on its own.
      headerLogo: 'images/2384/transition_logo.png',
      headerLogoKeepColor: true,
      headerLogoInvertInLight: true,
      // Cadillac's crest reads too small at the shared default header-logo size.
      headerLogoLarge: true,
      keyHighlights: [
        {
          index: 0,
          show: true,
          title: {
            en: '',
            ar: ''
          },
          value: {
            en: '237 HP',
            ar: '237 حصاناً'
          },
          unit: ''
        },
        {
          index: 1,
          show: true,
          title: {
            en: 'Torque',
            ar: 'عزم الدوران'
          },
          value: {
            en: '350 NM',
            ar: '350 نيوتن متر'
          },
          unit: ''
        },
        {
          index: 2,
          show: true,
          title: {
            en: 'I4 Engine',
            ar: 'محرك I4'
          },
          value: {
            en: '2.0L',
            ar: '2.0 لتر'
          },
          unit: ''
        }
      ]
    }
  },
  saveFormConfig: {
    fields: [
      {
        id: 'firstName',
        type: 'text',
        required: true,
        labelKey: 'saveDialog.labelFirstName',
        placeholderKey: 'saveDialog.placeholderFirstName',
      },
      {
        id: 'lastName',
        type: 'text',
        required: true,
        labelKey: 'saveDialog.labelLastName',
        placeholderKey: 'saveDialog.placeholderLastName',
      },
      {
        id: 'email',
        type: 'email',
        required: true,
        labelKey: 'saveDialog.labelEmail',
        placeholderKey: 'saveDialog.placeholderEmail',
        visibility: ['email', 'test-drive', 'callback'],
      },
      {
        id: 'phone',
        type: 'phone',
        required: true,
        labelKey: 'saveDialog.labelMobileNumber',
        placeholderKey: 'saveDialog.placeholderMobileNumber',
        visibility: ['whatsapp', 'test-drive', 'callback'],
      },
      {
        id: 'model',
        type: 'select',
        required: true,
        labelKey: 'saveDialog.labelModel',
        placeholderKey: 'saveDialog.labelModel',
        optionsSource: 'models',
        visibility: ['test-drive', 'callback'],
      },
      {
        id: 'dealer',
        type: 'select',
        required: true,
        labelKey: 'saveDialog.labelDealership',
        placeholderKey: 'saveDialog.placeholderSelectDealership',
        optionsSource: 'dealers',
        visibility: [
          'test-drive',
          'callback',
          'whatsapp',
          'email',
        ],
        // 1.0's save forms show the dealership dropdown but do not gate
        // submission on it; only the booking forms require it.
        requiredFor: [
          'test-drive',
          'callback',
        ],
      },
      {
        id: 'testDriveDate',
        type: 'date',
        required: true,
        labelKey: 'saveDialog.labelTestDriveDate',
        placeholderKey: 'saveDialog.placeholderTestDriveDate',
        visibility: [
          'test-drive',
        ],
      },
      {
        id: 'testDriveTime',
        type: 'time',
        required: true,
        labelKey: 'saveDialog.labelTestDriveTime',
        placeholderKey: 'saveDialog.placeholderTestDriveTime',
        visibility: [
          'test-drive',
        ],
      },
      {
        id: 'comments',
        type: 'textarea',
        required: false,
        labelKey: 'saveDialog.labelComments',
        placeholderKey: 'saveDialog.placeholderComments',
        visibility: ['test-drive', 'callback'],
      },
    ],
  },
  externalScript: {
    dev: {
      head: {
        links: [
          {
            snippet: 'https://assets.adobedtm.com/ea8c57fea068/636ca1404ad1/launch-bea0833819b4-development.min.js',
            iframe: true,
            standalone: true
          },
          {
            snippet: 'https://assets.gm.com/responsive-iframe.min.js',
            iframe: true,
            standalone: true
          },
          {
            snippet: 'https://cmp.osano.com/3j6afV3OqT/4661232f-0324-44a1-bbfd-07fe470494c7/osano.js',
            iframe: false,
            standalone: true
          }
        ],
        snippets: [
          {
            snippet: '<!-- Meta Pixel Code -->\n<script>\n!function(f,b,e,v,n,t,s)\n{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\nn.callMethod.apply(n,arguments):n.queue.push(arguments)};\nif(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';\nn.queue=[];t=b.createElement(e);t.async=!0;\nt.src=v;s=b.getElementsByTagName(e)[0];\ns.parentNode.insertBefore(t,s)}(window, document,\'script\',\n\'https://connect.facebook.net/en_US/fbevents.js\');\nfbq(\'init\', \'1229872545572335\');\nfbq(\'track\', \'PageView\');\n</script>\n<noscript><img height="1" width="1" style="display:none"\nsrc="https://www.facebook.com/tr?id=1229872545572335&ev=PageView&noscript=1"\n/></noscript>\n<!-- End Meta Pixel Code -->\n\n        ',
            iframe: true,
            standalone: true
          }
        ]
      },
      body: {
        snippets: [
          {
            snippet: '<script type="text/javascript">_satellite.pageBottom();</script>',
            iframe: true,
            standalone: true,
            async: false
          }
        ]
      }
    },
    staging: {
      head: {
        links: [
          {
            snippet: 'https://assets.adobedtm.com/ea8c57fea068/636ca1404ad1/launch-85b05c76e071.min.js',
            iframe: true,
            standalone: true,
            async: false
          },
          {
            snippet: 'https://assets.gm.com/responsive-iframe.min.js',
            iframe: true,
            standalone: true
          },
          {
            snippet: 'https://cmp.osano.com/3j6afV3OqT/4661232f-0324-44a1-bbfd-07fe470494c7/osano.js',
            iframe: false,
            standalone: true
          }
        ],
        snippets: [
          {
            snippet: '<!-- Meta Pixel Code -->\n<script>\n!function(f,b,e,v,n,t,s)\n{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\nn.callMethod.apply(n,arguments):n.queue.push(arguments)};\nif(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';\nn.queue=[];t=b.createElement(e);t.async=!0;\nt.src=v;s=b.getElementsByTagName(e)[0];\ns.parentNode.insertBefore(t,s)}(window, document,\'script\',\n\'https://connect.facebook.net/en_US/fbevents.js\');\nfbq(\'init\', \'1229872545572335\');\nfbq(\'track\', \'PageView\');\n</script>\n<noscript><img height="1" width="1" style="display:none"\nsrc="https://www.facebook.com/tr?id=1229872545572335&ev=PageView&noscript=1"\n/></noscript>\n<!-- End Meta Pixel Code -->\n\n        ',
            iframe: true,
            standalone: true
          }
        ]
      },
      body: {
        snippets: [
          {
            snippet: '<script type="text/javascript">_satellite.pageBottom();</script>',
            iframe: true,
            standalone: true,
            async: false
          }
        ]
      }
    },
    main: {
      head: {
        links: [
          {
            snippet: 'https://assets.adobedtm.com/ea8c57fea068/636ca1404ad1/launch-85b05c76e071.min.js',
            iframe: true,
            standalone: true,
            async: false
          },
          {
            snippet: 'https://assets.gm.com/responsive-iframe.min.js',
            iframe: true,
            standalone: true
          },
          {
            snippet: 'https://cmp.osano.com/3j6afV3OqT/4661232f-0324-44a1-bbfd-07fe470494c7/osano.js',
            iframe: false,
            standalone: true
          }
        ],
        snippets: [
          {
            snippet: '<!-- Meta Pixel Code -->\n<script>\n!function(f,b,e,v,n,t,s)\n{if(f.fbq)return;n=f.fbq=function(){n.callMethod?\nn.callMethod.apply(n,arguments):n.queue.push(arguments)};\nif(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';\nn.queue=[];t=b.createElement(e);t.async=!0;\nt.src=v;s=b.getElementsByTagName(e)[0];\ns.parentNode.insertBefore(t,s)}(window, document,\'script\',\n\'https://connect.facebook.net/en_US/fbevents.js\');\nfbq(\'init\', \'1229872545572335\');\nfbq(\'track\', \'PageView\');\n</script>\n<noscript><img height="1" width="1" style="display:none"\nsrc="https://www.facebook.com/tr?id=1229872545572335&ev=PageView&noscript=1"\n/></noscript>\n<!-- End Meta Pixel Code -->\n        ',
            iframe: true,
            standalone: true
          }
        ]
      },
      body: {
        snippets: [
          {
            snippet: '<script type="text/javascript">_satellite.pageBottom();</script>',
            iframe: true,
            standalone: true,
            async: false
          }
        ]
      }
    }
  },
  // Single trim — nothing to filter on.
  filterOptions: [],
  // Brand theme tokens for Cadillac CT5.
  // Colors extracted from the Figma design (node 1786:10691):
  //   --brand-primary  #1a1971  (Cadillac deep blue — selected borders, CTAs, toggle)
  //   --brand-secondary #191897 (gradient end for toggle)
  //   --brand-surface  #f3f3f3  (selected card background)
  //   --brand-border-selected #1a1971
  // Font: Cadillac Gothic (Bold / Regular / Medium) per Figma.
  // Falls back to Chevy Sans → Satoshi → Inter if Cadillac Gothic is unavailable.
  styleConfig: {
    cssVariables: {
      '--default-font-family': "'Cadillac Gothic', 'Chevy Sans', sans-serif",
      '--bold-font-family': "'Cadillac Gothic', 'Chevy Sans Medium', sans-serif",
      '--brand-primary': '#1a1971',
      '--brand-primary-hover': '#15146a',
      '--brand-secondary': '#191897',
      '--brand-accent': '#1a1971',
      '--brand-accent-hover': '#15146a',
      '--brand-accent-light': '#e8e8f0',
      '--brand-surface': '#f3f3f3',
      '--brand-surface-alt': '#f3f4f6',
      '--brand-text': '#000000',
      '--brand-text-secondary': '#666666',
      '--brand-text-tertiary': '#bebebe',
      '--brand-border': '#e6e6e6',
      '--brand-border-selected': '#1a1971',
      '--brand-card-bg': '#ffffff',
      '--brand-toggle-gradient-from': '#1a1971',
      '--brand-toggle-gradient-to': '#191897',
      '--brand-toggle-knob-border': '#1a1971',
      '--brand-accent-secondary': '#1a1971',
      // Cadillac uses sharp corners (0) per Figma design
      '--brand-card-radius': '0px',
      '--brand-card-radius-sm': '0px',
      '--brand-card-radius-lg': '0px',
      '--brand-button-radius': '0px',
      '--brand-button-radius-sm': '0px',
      '--brand-pill-radius': '50px',
      '--brand-cta-radius': '0px',
      // Enter-CTA fill: white with the Cadillac blue chevron, rather than
      // the default #0072ce block.
      '--brand-cta-arrow-bg': '#ffffff',
      '--brand-cta-arrow-fg': '#1a1971',
      '--brand-cta-shimmer': '#ffffff',
      '--enter-configurator-text-shadow': '0px 0px 12px #000000',
      '--brand-button-border': '#ffffff',
      '--brand-dialog-radius': '0px',
      '--brand-dialog-option-radius': '0px',
    },
  },
} as unknown as UIMetadataComplete;
